/* galaxy-iq tracker | tenant org_9280408b-69f0-4ba6-9705-ce96ff410c03 | 9 events | generated 2026-09-09T06:25:43.487Z */
/*!
 * Galaxy IQ tracker runtime
 *
 * Generated per tenant. Do not edit this file directly -- edit
 * src/runtime/tracker.template.js and re-run the generator.
 *
 * The AI event spec describes what to measure ("Book a Call", Conversion) and
 * almost never a selector -- the model sees the scraped page's prose, not its
 * DOM. So this runtime resolves each event to real elements at load time
 * using text, href, URL and section-heading heuristics, strengthened by a
 * CSS selector (trigger.selector) when the digest offered a stable id/testid
 * to copy. Heuristics miss; `data-iq-event="<key>"` on an element is always
 * an exact override, and debug mode reports which rules matched nothing. A
 * trigger can also carry `pagePaths`, restricting it to the pages named in
 * the spec's `page_paths` instead of the whole site.
 */
(function (window, document) {
  'use strict';

  var CONFIG = {
  "version": "1.0.0",
  "batchSize": 20,
  "flushIntervalMs": 5000,
  "sessionTimeoutMs": 1800000,
  "scrollDepths": [
    25,
    50,
    75,
    100
  ],
  "readDwellMs": 3000,
  "readVisibleRatio": 0.5,
  "maxPropertyKeys": 25,
  "maxPropertyChars": 512,
  "ignoreDoNotTrack": false,
  "debug": false,
  "autocapture": {
    "enabled": true,
    "clicks": true,
    "sections": true,
    "fields": true,
    "images": true,
    "media": true,
    "embeds": true,
    "embedRewrite": true,
    "rage": true,
    "selection": true,
    "products": true,
    "choices": true
  },
  "product": {
    "cardSelector": null,
    "maxCards": 40,
    "impressionRatio": 0.5,
    "impressionMs": 300,
    "rescanMs": [
      800,
      2500
    ],
    "commitMs": 700
  },
  "mediaMilestones": [
    25,
    50,
    75,
    95
  ],
  "searchParams": [
    "q",
    "s",
    "query",
    "search",
    "keyword",
    "term"
  ],
  "endpoint": "http://localhost:8000/collect",
  "tenantId": "org_9280408b-69f0-4ba6-9705-ce96ff410c03",
  "siteId": "org_9280408b-69f0-4ba6-9705-ce96ff410c03",
  "generatedAt": "2026-09-09T06:25:43.487Z",
  "rules": [
    {
      "key": "checkout_click",
      "label": "Checkout",
      "category": "Conversion",
      "triggers": [
        {
          "type": "click",
          "text": [
            "checkout",
            "cartdrawer-checkout"
          ],
          "href": [
            "/checkout",
            "/cartdrawer-checkout"
          ],
          "selector": "#CartDrawer-Checkout",
          "scopeHeading": []
        }
      ],
      "dedupe": "none"
    },
    {
      "key": "add_to_cart",
      "label": "Add to Cart",
      "category": "Conversion",
      "triggers": [
        {
          "type": "click",
          "text": [
            "button (class",
            "add to cart",
            "add cart"
          ],
          "href": [
            "/add-to-cart",
            "/addtocart",
            "/button-class"
          ],
          "selector": "",
          "scopeHeading": []
        }
      ],
      "dedupe": "none"
    },
    {
      "key": "contact_form_submission",
      "label": "Contact Form Submission",
      "category": "Conversion",
      "triggers": [
        {
          "type": "submit",
          "context": [
            "contact",
            "get in touch",
            "send us a message",
            "talk to sales",
            "how can we help",
            "enquiry",
            "inquiry",
            "reach out",
            "contact form",
            "contact form submission",
            "/contact#contactform",
            "send"
          ],
          "requiresEmail": false,
          "emailOnlyFallback": false,
          "selector": "",
          "pagePaths": [
            "/pages/contact"
          ]
        },
        {
          "type": "click",
          "href": [
            "mailto:"
          ],
          "text": [],
          "pagePaths": [
            "/pages/contact"
          ]
        }
      ],
      "dedupe": "none"
    },
    {
      "key": "faq_interaction",
      "label": "FAQ Interaction",
      "category": "Engagement",
      "triggers": [
        {
          "type": "click",
          "selector": "details > summary, [aria-expanded], [aria-controls], [data-state], [class*=\"accordion\"], [class*=\"faq\"] button, [class*=\"faq\"] [role=\"button\"]",
          "scopeHeading": [
            "faq",
            "frequently asked",
            "common question",
            "questions",
            "faqs",
            "faq interaction"
          ],
          "text": [],
          "maxTextLength": 240,
          "pagePaths": [
            "/pages/faqs"
          ]
        }
      ],
      "dedupe": "none"
    },
    {
      "key": "view_cart_click",
      "label": "View Cart",
      "category": "Engagement",
      "triggers": [
        {
          "type": "click",
          "text": [
            "view cart"
          ],
          "href": [
            "/view-cart",
            "/viewcart"
          ],
          "selector": "",
          "scopeHeading": []
        }
      ],
      "dedupe": "none"
    },
    {
      "key": "continue_shopping_click",
      "label": "Continue Shopping",
      "category": "Engagement",
      "triggers": [
        {
          "type": "click",
          "text": [
            "continue shopping"
          ],
          "href": [
            "/continue-shopping",
            "/continueshopping"
          ],
          "selector": "",
          "scopeHeading": []
        }
      ],
      "dedupe": "none"
    },
    {
      "key": "create_account",
      "label": "Create Account",
      "category": "Conversion",
      "triggers": [
        {
          "type": "click",
          "text": [
            "create account"
          ],
          "href": [
            "/create-account",
            "/createaccount"
          ],
          "selector": "",
          "scopeHeading": []
        }
      ],
      "dedupe": "none",
      "resourceType": "external_app",
      "resourceHint": "shopify.com"
    },
    {
      "key": "customer_login",
      "label": "Log In",
      "category": "Engagement",
      "triggers": [
        {
          "type": "click",
          "text": [
            "log in",
            "hello, sign in",
            "customer login"
          ],
          "href": [
            "/customer-login",
            "/customerlogin",
            "/log-in",
            "/hello-sign-in"
          ],
          "selector": "",
          "scopeHeading": []
        }
      ],
      "dedupe": "none"
    },
    {
      "key": "book_appointment",
      "label": "Book an Appointment",
      "category": "Conversion",
      "triggers": [
        {
          "type": "click",
          "text": [
            "book an appointment",
            "book appointment"
          ],
          "href": [
            "/book-appointment",
            "/bookappointment",
            "/book-an-appointment"
          ],
          "selector": "",
          "scopeHeading": []
        }
      ],
      "dedupe": "none"
    }
  ]
};

  if (!window || !document) return;

  // Script-tag overrides. The endpoint is baked in at build time, but one
  // built file needs to work against localhost, an ngrok tunnel and
  // production without a rebuild each time:
  //
  //   <script src="tracker.js" data-endpoint="https://abc.ngrok.app/collect"></script>
  //
  // document.currentScript is still the <script> element while this IIFE runs
  // (true for defer/async too), so read it before anything yields.
  try {
    var tag = document.currentScript;
    if (tag && tag.dataset) {
      if (tag.dataset.endpoint) CONFIG.endpoint = tag.dataset.endpoint;
      if (tag.dataset.siteId) CONFIG.siteId = tag.dataset.siteId;
      if (tag.dataset.debug) CONFIG.debug = tag.dataset.debug !== 'false';
    }
  } catch (e) {}

  // Same overrides via a global, for when there is no script tag to read:
  // pasting the script into a DevTools console or a bookmarklet leaves
  // document.currentScript null, and the baked-in localhost endpoint would
  // then be blocked as mixed content on an https page.
  //
  //   window.__galaxyIQOptions = { endpoint: 'https://…/collect', debug: true };
  try {
    var opts = window.__galaxyIQOptions;
    if (opts && typeof opts === 'object') {
      if (opts.endpoint) CONFIG.endpoint = opts.endpoint;
      if (opts.siteId) CONFIG.siteId = opts.siteId;
      if (typeof opts.debug === 'boolean') CONFIG.debug = opts.debug;
    }
  } catch (e) {}
  if (window.__galaxyIQ) return; // already loaded
  if (navigator.doNotTrack === '1' || window.doNotTrack === '1') {
    // TODO(consent): wire this to the site's real consent manager instead of
    // DNT alone before running in regulated markets.
    if (!CONFIG.ignoreDoNotTrack) return;
  }

  // ---------------------------------------------------------------- helpers

  function noop() {}

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function safeStorage(name) {
    try {
      var s = window[name];
      var probe = '__iq_probe__';
      s.setItem(probe, '1');
      s.removeItem(probe);
      return s;
    } catch (e) {
      return null; // private mode, blocked cookies, sandboxed iframe
    }
  }

  var local = safeStorage('localStorage');
  var session = safeStorage('sessionStorage');

  function uuid() {
    try {
      if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
      if (window.crypto && window.crypto.getRandomValues) {
        var b = new Uint8Array(16);
        window.crypto.getRandomValues(b);
        b[6] = (b[6] & 0x0f) | 0x40;
        b[8] = (b[8] & 0x3f) | 0x80;
        var hex = [];
        for (var i = 0; i < 16; i++) hex.push((b[i] + 0x100).toString(16).slice(1));
        return (
          hex.slice(0, 4).join('') + '-' + hex.slice(4, 6).join('') + '-' +
          hex.slice(6, 8).join('') + '-' + hex.slice(8, 10).join('') + '-' +
          hex.slice(10, 16).join('')
        );
      }
    } catch (e) {}
    return 'x' + Date.now().toString(16) + Math.random().toString(16).slice(2, 10);
  }

  /** Lowercased, whitespace-collapsed text of an element. */
  function textOf(el) {
    if (!el) return '';
    var t = el.getAttribute && el.getAttribute('aria-label');
    if (!t) t = el.innerText || el.textContent || '';
    return String(t).replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function normalize(s) {
    return String(s == null ? '' : s).replace(/\s+/g, ' ').trim().toLowerCase();
  }

  /** Longest pattern in `patterns` contained in `haystack`, or null. */
  function bestContained(haystack, patterns) {
    if (!haystack || !patterns) return null;
    var best = null;
    for (var i = 0; i < patterns.length; i++) {
      var p = patterns[i];
      if (p && haystack.indexOf(p) !== -1 && (!best || p.length > best.length)) best = p;
    }
    return best;
  }

  /**
   * Is the current page one this trigger is armed on. `pagePaths` comes from
   * the spec's `page_paths` -- absent or ["*"] (the common case, unset by
   * the generator) means everywhere, otherwise each pattern is a path
   * prefix, with a trailing "/*" meaning "this and anything under it".
   */
  function pageScopeAllows(trigger) {
    var paths = trigger.pagePaths;
    if (!paths || !paths.length) return true;
    var path = normalize(location.pathname) || '/';
    for (var i = 0; i < paths.length; i++) {
      var p = normalize(paths[i]);
      if (!p || p === '*') return true;
      if (p.slice(-2) === '/*') {
        if (path.indexOf(p.slice(0, -2)) === 0) return true;
      } else if (path === p || path.indexOf(p) === 0) {
        return true;
      }
    }
    return false;
  }

  function isVisible(el) {
    if (!el || !el.getBoundingClientRect) return false;
    var r = el.getBoundingClientRect();
    if (r.width === 0 && r.height === 0) return false;
    try {
      var cs = window.getComputedStyle(el);
      if (cs && (cs.display === 'none' || cs.visibility === 'hidden')) return false;
    } catch (e) {}
    return true;
  }

  function log() {
    if (!CONFIG.debug || !window.console) return;
    var args = toArray(arguments);
    args.unshift('%c[galaxy-iq]', 'color:#7c3aed;font-weight:bold');
    (console.info || console.log).apply(console, args);
  }

  // ---------------------------------------------------------------- identity

  var isFirstVisit = false;
  var isNewSession = false;

  function getVisitorId() {
    var key = 'iq_visitor_id';
    var id = local && local.getItem(key);
    if (!id) {
      // No stored id means either a genuinely new person or storage we cannot
      // write to. Both look identical from here, so private-mode traffic
      // inflates first_visit -- worth knowing before trusting the number.
      isFirstVisit = true;
      id = uuid();
      if (local) try { local.setItem(key, id); } catch (e) {}
    }
    return id;
  }

  function getSessionId() {
    var idKey = 'iq_session_id';
    var tsKey = 'iq_session_ts';
    var now = Date.now();
    var id = session && session.getItem(idKey);
    var last = session && parseInt(session.getItem(tsKey) || '0', 10);
    if (!id || !last || now - last > CONFIG.sessionTimeoutMs) {
      id = uuid();
      isNewSession = true;
    }
    if (session) {
      try {
        session.setItem(idKey, id);
        session.setItem(tsKey, String(now));
      } catch (e) {}
    }
    return id;
  }

  var visitorId = getVisitorId();

  // ------------------------------------------------------------ attribution
  //
  // Without this the tracker can record that a book_a_call happened and not
  // which campaign caused it, which is most of the reason anyone runs
  // analytics at all.
  //
  // Captured once per session and stored, because the UTM parameters are only
  // on the landing URL: by the time someone converts three pages later the
  // query string is long gone. First touch within the session wins -- a later
  // internal link with its own tags does not overwrite the campaign that
  // actually brought them in.

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  var CLICK_IDS = ['gclid', 'fbclid', 'msclkid', 'ttclid', 'twclid', 'li_fat_id', 'igshid'];

  function queryParam(name) {
    try {
      var m = new RegExp('[?&]' + name + '=([^&#]*)').exec(location.search);
      return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : '';
    } catch (e) { return ''; }
  }

  var SEARCH_HOSTS = /google\.|bing\.|duckduckgo\.|yahoo\.|baidu\.|yandex\.|ecosia\.|brave\.com|search\./i;
  var SOCIAL_HOSTS = /facebook\.|instagram\.|linkedin\.|twitter\.|x\.com|t\.co|reddit\.|youtube\.|tiktok\.|pinterest\.|threads\./i;

  /** direct | internal | search | social | referral -- the channel, not the URL. */
  function classifyReferrer(ref) {
    if (!ref) return 'direct';
    var host = '';
    try { host = new URL(ref).hostname; } catch (e) { return 'referral'; }
    if (host === location.hostname) return 'internal';
    if (SEARCH_HOSTS.test(host)) return 'search';
    if (SOCIAL_HOSTS.test(host)) return 'social';
    return 'referral';
  }

  function buildAttribution() {
    var attr = {};
    for (var i = 0; i < UTM_KEYS.length; i++) {
      var v = queryParam(UTM_KEYS[i]);
      if (v) attr[UTM_KEYS[i]] = v.slice(0, 200);
    }
    for (var c = 0; c < CLICK_IDS.length; c++) {
      var id = queryParam(CLICK_IDS[c]);
      if (id) { attr.click_id = id.slice(0, 200); attr.click_id_type = CLICK_IDS[c]; break; }
    }
    var ref = document.referrer || '';
    attr.channel = classifyReferrer(ref);
    if (ref && attr.channel !== 'internal') {
      attr.referrer = ref.slice(0, 300);
      try { attr.referrer_host = new URL(ref).hostname; } catch (e) {}
    }
    attr.landing_page = location.pathname + (location.search || '').slice(0, 200);
    return attr;
  }

  function getAttribution() {
    var key = 'iq_attribution';
    if (!isNewSession && session) {
      try {
        var stored = session.getItem(key);
        if (stored) return JSON.parse(stored);
      } catch (e) {}
    }
    var attr = buildAttribution();
    if (session) try { session.setItem(key, JSON.stringify(attr)); } catch (e) {}
    return attr;
  }

  /**
   * The device the page actually rendered on.
   *
   * The collector already derives browser and OS from the User-Agent, but that
   * says nothing about the window it was rendered in -- and a 380px viewport
   * and a 2560px one are different products.
   */
  function clientContext() {
    var ctx = {};
    try {
      ctx.viewport_w = window.innerWidth;
      ctx.viewport_h = window.innerHeight;
      ctx.screen_w = screen && screen.width;
      ctx.screen_h = screen && screen.height;
      ctx.pixel_ratio = window.devicePixelRatio || 1;
      ctx.language = navigator.language || '';
      ctx.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      var conn = navigator.connection;
      if (conn && conn.effectiveType) ctx.connection = conn.effectiveType;
    } catch (e) {}
    return ctx;
  }

  // --------------------------------------------------------------- transport

  var queue = [];
  var flushTimer = null;

  function currentUrl() {
    return location.pathname + location.search;
  }

  function capProps(props) {
    var out = {};
    var n = 0;
    for (var k in props) {
      if (!Object.prototype.hasOwnProperty.call(props, k)) continue;
      if (n >= CONFIG.maxPropertyKeys) break;
      var v = props[k];
      if (v === undefined || v === null || v === '') continue;
      if (typeof v === 'string' && v.length > CONFIG.maxPropertyChars) {
        v = v.slice(0, CONFIG.maxPropertyChars);
      }
      out[k] = v;
      n++;
    }
    return out;
  }

  function track(name, props) {
    if (!name) return;
    var enriched = props || {};
    // Every event carries the embedding host: site_id is the tenant, which
    // says nothing about which of a tenant's domains fired this.
    enriched.site_host = location.hostname;
    var event = {
      name: name,
      url: currentUrl(),
      title: document.title,
      ts: new Date().toISOString(),
      visitor_id: visitorId,
      session_id: getSessionId(),
      site_id: CONFIG.siteId,
      properties: capProps(enriched)
    };
    queue.push(event);
    log('event', name, event.properties);
    try {
      window.dispatchEvent(new CustomEvent('iq:event', { detail: event }));
    } catch (e) {}
    if (queue.length >= CONFIG.batchSize) flush(false);
    else scheduleFlush();
    return event;
  }

  function scheduleFlush() {
    if (flushTimer) return;
    flushTimer = window.setTimeout(function () {
      flushTimer = null;
      flush(false);
    }, CONFIG.flushIntervalMs);
  }

  function flush(useBeacon) {
    if (flushTimer) {
      window.clearTimeout(flushTimer);
      flushTimer = null;
    }
    if (!queue.length) return;
    var batch = queue.slice(0);
    queue.length = 0;
    var body = JSON.stringify({ type: 'batch', payload: batch });

    // On unload only sendBeacon is reliable -- fetch gets cancelled. It also
    // cannot report success, which is why the collector accepts partial
    // batches rather than rejecting them.
    //
    // The blob is text/plain, NOT application/json. application/json is not a
    // CORS-safelisted content type, so the beacon would need a preflight --
    // and a preflight cannot complete while the page is unloading, so Chrome
    // drops the request (verified: OPTIONS then POST net::ERR_FAILED, versus a
    // clean 202 with text/plain). The body is identical JSON either way, and
    // the collector parses both content types for exactly this reason.
    if (useBeacon && navigator.sendBeacon) {
      try {
        var blob = new Blob([body], { type: 'text/plain;charset=UTF-8' });
        if (navigator.sendBeacon(CONFIG.endpoint, blob)) return;
      } catch (e) {}
    }
    try {
      window.fetch(CONFIG.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body,
        keepalive: true,
        mode: 'cors',
        credentials: 'omit'
      })['catch'](noop);
    } catch (e) {}
  }

  // ------------------------------------------------------- section discovery

  var HEADING_SELECTOR = 'h1,h2,h3,h4,h5,h6,[role="heading"]';
  var sectionCache = null;

  /**
   * The container a heading introduces.
   *
   * Climbs from the heading until it hits a semantic wrapper, or until the
   * ancestor holds meaningfully more text than the heading itself (i.e. it now
   * contains the section body, not just the title).
   */
  function containerFor(heading) {
    var semantic = heading.closest && heading.closest('section, article, aside, [role="region"]');
    if (semantic) return semantic;
    var node = heading.parentElement;
    var headingLen = (heading.textContent || '').length;
    var depth = 0;
    while (node && depth < 5) {
      var tag = (node.tagName || '').toLowerCase();
      if (tag === 'body' || tag === 'main' || tag === 'html') break;
      if ((node.textContent || '').length > headingLen * 3) return node;
      node = node.parentElement;
      depth++;
    }
    return heading.parentElement || heading;
  }

  /** All headings on the page, paired with their container. Cached per nav. */
  function allSections() {
    if (sectionCache) return sectionCache;
    sectionCache = [];
    var headings = toArray(document.querySelectorAll(HEADING_SELECTOR));
    var cardSel = acOn('products') ? pCfg('cardSelector', PRODUCT_CARD_SELECTOR) : null;
    for (var i = 0; i < headings.length; i++) {
      var h = headings[i];
      var t = textOf(h);
      if (!t || t.length > 160) continue;
      // A product card's title is a heading in markup and a label in meaning.
      // Counting forty of them as sections makes section_index -- "how far
      // down the page did they get" -- describe the grid instead of the page.
      if (cardSel) {
        var inCard = false;
        try { inCard = !!closestEl(h, cardSel); } catch (e) {}
        if (inCard) continue;
      }
      sectionCache.push({ heading: h, text: t, container: containerFor(h) });
    }
    return sectionCache;
  }

  /** Sections whose heading contains any of `patterns`. */
  function sectionsMatching(patterns) {
    var all = allSections();
    var out = [];
    for (var i = 0; i < all.length; i++) {
      if (bestContained(all[i].text, patterns)) out.push(all[i]);
    }
    return out;
  }

  function inAnySection(node, patterns) {
    var secs = sectionsMatching(patterns);
    for (var i = 0; i < secs.length; i++) {
      if (secs[i].container && secs[i].container.contains(node)) return secs[i];
    }
    return null;
  }

  // ------------------------------------------------------------- click rules

  var CLICKABLE = 'a,button,[role="button"],[role="link"],input[type="submit"],input[type="button"],summary,[onclick]';

  function isClickable(el, trigger) {
    if (trigger && trigger.selector) {
      try { if (el.matches(trigger.selector)) return true; } catch (e) {}
    }
    try { return el.matches(CLICKABLE); } catch (e) { return false; }
  }

  function hrefOf(el) {
    var h = el.getAttribute && (el.getAttribute('href') || el.getAttribute('data-href'));
    return h ? normalize(h) : '';
  }

  /**
   * Score how well `el` satisfies a click trigger. Higher wins.
   *
   * href beats text because a link target is structural, while visible text is
   * whatever a copywriter last decided. Selector beats both because it was
   * supplied deliberately.
   */
  function scoreClick(el, rule, trigger) {
    // The rule also has a submit trigger; letting the button click through
    // would report one newsletter signup as two events.
    if (trigger.skipInForm && el.closest && el.closest('form')) return null;
    if (!pageScopeAllows(trigger)) return null;

    var scope = null;
    if (trigger.scopeHeading && trigger.scopeHeading.length) {
      scope = inAnySection(el, trigger.scopeHeading);
      if (!scope) return null;
    }

    var props = { match: '' };
    var score = 0;

    if (trigger.selector) {
      try {
        if (el.matches(trigger.selector)) {
          score = 100;
          props.match = 'selector';
        }
      } catch (e) {}
    }

    if (!score && trigger.href && trigger.href.length) {
      var hit = bestContained(hrefOf(el), trigger.href);
      if (hit) {
        score = 80 + hit.length;
        props.match = 'href';
        props.matched_href = hit;
      }
    }

    if (!score && trigger.text && trigger.text.length && isClickable(el, trigger)) {
      var t = textOf(el);
      // A container can technically be "clickable"; refuse to attribute a whole
      // paragraph of text to a CTA match.
      if (t && t.length <= (trigger.maxTextLength || 120)) {
        var phrase = bestContained(t, trigger.text);
        if (phrase) {
          score = 40 + phrase.length;
          props.match = 'text';
          props.matched_text = phrase;
        }
      }
    }

    if (!score) return null;
    if (scope) {
      score += 10;
      props.section = scope.text.slice(0, 80);
    }
    return { rule: rule, trigger: trigger, score: score, props: props, el: el };
  }

  function elementProps(el) {
    var props = {};
    var tag = (el.tagName || '').toLowerCase();
    props.element = tag;
    var label = textOf(el);
    if (label) props.text = label.slice(0, 120);
    var href = el.getAttribute && el.getAttribute('href');
    if (href) props.href = String(href).slice(0, 512);
    var id = el.getAttribute && el.getAttribute('id');
    if (id) props.element_id = id;
    // data-iq-* attributes are the site owner's own annotations.
    var attrs = el.attributes || [];
    for (var i = 0; i < attrs.length; i++) {
      var a = attrs[i];
      if (a.name.indexOf('data-iq-') === 0 && a.name !== 'data-iq-event') {
        props[a.name.slice(8).replace(/-/g, '_')] = a.value;
      }
    }
    return props;
  }

  // =================================================================
  // Autocapture
  //
  // The spec-driven rules answer "did the thing we chose to measure
  // happen". They cannot answer "what else did people do", because an
  // unmatched click has always been silent -- and a rule that was never
  // written is indistinguishable from an interaction that never occurred.
  //
  // Autocapture closes that: every click is recorded with enough context to
  // define an event for it later, and every content section is recorded in
  // document order so "how far down did they get, and what did they
  // actually see" is answerable without a rule existing first.
  //
  // A matched click emits its semantic event, not a second autocapture one.
  // The element context below is attached either way, so coverage is total
  // without doubling the volume.
  // =================================================================

  var AC = CONFIG.autocapture || {};
  function acOn(key) {
    // Default on: a build predating this config should still capture.
    return AC.enabled !== false && AC[key] !== false;
  }

  /**
   * A selector that identifies this element to a human reading the data.
   *
   * Deliberately not guaranteed-unique: nth-of-type chains are brittle across
   * deploys, and a path that changes every release is worse than a readable
   * one that groups. id wins, then a stable-looking class, then the tag.
   */
  /**
   * Is this class name a word someone chose, or a hash a build tool emitted?
   *
   * Hashes change every deploy, so a selector built from one describes an
   * element that will not exist next week -- every funnel grouped on it
   * silently splits in two. Prefix lists (css-, sc-, jsx-) only catch the
   * tools that announce themselves: Flipkart ships `nc3hzK`, `v1zwn20`,
   * `jaZAME` and `_1psv1ze0`, none of which carry a prefix.
   *
   * So this allows a shape rather than denying a list. Lowercase kebab or
   * snake (`product-card`, `a-carousel-card`) and plain camelCase
   * (`productCard`) are what people type; everything else is assumed
   * generated. Conservative on purpose -- a real class wrongly dropped
   * costs one nth-of-type segment, while a hash wrongly kept costs the
   * whole join.
   */
  function isWordClass(c) {
    if (!c || c.length < 2 || c.length > 40) return false;
    if (/[0-9]{3,}/.test(c)) return false;
    var kebab = /^[a-z][a-z0-9]*(?:[-_]{1,2}[a-z0-9]+)*$/.test(c);
    var camel = /^[a-z]+(?:[A-Z][a-z]+)*$/.test(c);
    if (!kebab && !camel) return false;
    // A word has a vowel. `v1zwn20` passes the kebab shape and is still a hash.
    var letters = c.replace(/[^a-zA-Z]/g, '');
    return letters.length < 4 || /[aeiou]/i.test(letters);
  }

  /** 1-based position among same-tag siblings -- the stable-ish last resort. */
  function nthOfType(el) {
    var n = 1;
    var sib = el.previousElementSibling;
    while (sib) {
      if (sib.tagName === el.tagName) n++;
      sib = sib.previousElementSibling;
    }
    return n;
  }

  function cssPath(el) {
    var parts = [];
    var node = el;
    var depth = 0;
    while (node && node.nodeType === 1 && depth < 5) {
      var tag = (node.tagName || '').toLowerCase();
      if (tag === 'body' || tag === 'html') break;
      var id = node.getAttribute && node.getAttribute('id');
      if (id) { parts.unshift('#' + id); break; }
      var seg = tag;
      var cls = node.getAttribute && node.getAttribute('class');
      if (cls) {
        var stable = String(cls).trim().split(/\s+/).filter(isWordClass);
        if (stable.length) seg += '.' + stable.slice(0, 2).join('.');
        else if (node.parentElement) seg += ':nth-of-type(' + nthOfType(node) + ')';
      }
      parts.unshift(seg);
      node = node.parentElement;
      depth++;
    }
    return parts.join(' > ').slice(0, 240);
  }

  /** Which section of the page an element sits in, and how far down it is. */
  function sectionIndexOf(el) {
    var all = allSections();
    for (var i = all.length - 1; i >= 0; i--) {
      if (all[i].container && all[i].container.contains(el)) {
        return { heading: all[i].text, index: i + 1, total: all.length };
      }
    }
    return null;
  }

  // GA4's file_download extension list, which is as good a definition of "a
  // document rather than a page" as any.
  var DOWNLOAD_EXT = /\.(pdf|xlsx?|docx?|txt|rtf|csv|exe|key|pps|pptx?|7z|pkg|rar|gz|zip|dmg|avi|mov|mp4|mpe?g|wmv|midi?|mp3|wav|wma)($|\?)/i;

  /**
   * Outbound, download, or neither.
   *
   * Every click is already captured; this only says what kind of link it was.
   * A link off the site and a link to a PDF are the two that conventionally
   * get their own events, because neither produces a page_view -- the visit
   * simply ends, and without this the session looks like an unexplained exit.
   */
  function linkKind(el) {
    var raw = el && el.getAttribute && el.getAttribute('href');
    if (!raw) return null;
    if (/^(mailto:|tel:|javascript:|#)/i.test(raw)) return null;
    var url;
    try { url = new URL(raw, location.href); } catch (e) { return null; }
    if (!/^https?:$/.test(url.protocol)) return null;
    return {
      url: url,
      outbound: url.hostname !== location.hostname,
      download: DOWNLOAD_EXT.test(url.pathname) || el.hasAttribute('download')
    };
  }

  /** Everything knowable about the element that was interacted with. */
  function autoProps(el, skipProduct) {
    var props = {};
    try {
      props.selector = cssPath(el);
      var cls = el.getAttribute && el.getAttribute('class');
      if (cls) props.element_class = String(cls).slice(0, 120);
      var role = el.getAttribute && (el.getAttribute('role') || el.getAttribute('aria-label'));
      if (role) props.role = String(role).slice(0, 60);
      if (el.disabled) props.disabled = true;

      var sec = sectionIndexOf(el);
      if (sec) {
        props.section = sec.heading.slice(0, 80);
        props.section_index = sec.index;   // 1 = topmost section on the page
        props.section_total = sec.total;
      }

      // Where on the page, as a fraction -- resolution-independent, so a
      // laptop and a monitor produce comparable numbers.
      var kind = linkKind(el);
      if (kind) {
        if (kind.outbound) {
          props.outbound = true;
          props.link_domain = kind.url.hostname;
        }
        if (kind.download) props.file_extension = (kind.url.pathname.split('.').pop() || '').toLowerCase().slice(0, 10);
      }

      var r = el.getBoundingClientRect();
      var docH = Math.max(document.documentElement.scrollHeight, 1);
      props.page_y = Math.round(((window.pageYOffset || 0) + r.top) / docH * 100) / 100;
      props.viewport_x = Math.round((r.left + r.width / 2) / Math.max(window.innerWidth, 1) * 100) / 100;

      // Which product this happened inside, when the page has one. Identity
      // only -- the full metadata rides on $product_view/$product_impression.
      if (!skipProduct) {
        var prod = productContext(el);
        if (prod) props = mergeProps(props, prod);
      }
    } catch (e) {}
    return props;
  }

  function handleClick(e) {
    var node = e.target;
    if (node && node.nodeType === 3) node = node.parentElement;
    var best = null;
    var depth = 0;

    while (node && node.nodeType === 1 && depth < 12) {
      var manual = node.getAttribute && node.getAttribute('data-iq-event');
      if (manual) {
        // An explicit annotation is authoritative -- stop looking.
        var manualRule = ruleByKey[manual];
        emit(manualRule, manual, mergeProps(elementProps(node), { match: 'data-attribute' }));
        return;
      }
      for (var r = 0; r < CONFIG.rules.length; r++) {
        var rule = CONFIG.rules[r];
        for (var t = 0; t < rule.triggers.length; t++) {
          var trigger = rule.triggers[t];
          if (trigger.type !== 'click') continue;
          var hit = scoreClick(node, rule, trigger);
          if (hit && (!best || hit.score > best.score)) best = hit;
        }
      }
      if (best && best.score >= 100) break; // selector match, no better available
      node = node.parentElement;
      depth++;
    }

    if (best) {
      // A matched click already carries its rule. Attach the same element
      // context so matched and unmatched clicks are queryable the same way.
      var matchedProps = mergeProps(elementProps(best.el), best.props);
      if (acOn('clicks')) matchedProps = mergeProps(autoProps(best.el), matchedProps);
      emit(best.rule, best.rule.key, matchedProps);
      return;
    }

    // Nothing claimed it. Previously this was where the signal died.
    if (!acOn('clicks')) return;
    var target = e.target;
    if (target && target.nodeType === 3) target = target.parentElement;
    if (!target || target.nodeType !== 1) return;

    // Walk up to the thing a person would say they clicked: the button, not
    // the <span> inside it.
    var subject = target;
    var up = 0;
    while (subject && up < 4 && !isClickable(subject)) {
      subject = subject.parentElement;
      up++;
    }
    if (!subject || subject.nodeType !== 1) subject = target;

    var kind = linkKind(subject);
    if (kind && kind.download) {
      track('$file_download', mergeProps(autoProps(subject), mergeProps(elementProps(subject), {
        file_name: kind.url.pathname.split('/').pop().slice(0, 120),
        match: 'autocapture'
      })));
      return;
    }

    watchForCommit(subject);
    track('$click', mergeProps(autoProps(subject), mergeProps(elementProps(subject), {
      match: 'autocapture',
      interactive: isClickable(subject) || undefined
    })));
  }

  // ------------------------------------------------------------ submit rules

  /** Field *names* only. Values are never read -- they are user PII. */
  function formProps(form) {
    var props = {};
    if (form.getAttribute) {
      var id = form.getAttribute('id');
      var name = form.getAttribute('name');
      var action = form.getAttribute('action');
      if (id) props.form_id = id;
      if (name) props.form_name = name;
      if (action) props.form_action = String(action).slice(0, 256);
    }
    var fields = toArray(form.querySelectorAll('input,select,textarea'));
    var names = [];
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      var type = (f.getAttribute('type') || 'text').toLowerCase();
      if (type === 'hidden' || type === 'password') continue;
      var n = f.getAttribute('name') || f.getAttribute('id');
      if (n && names.indexOf(n) === -1) names.push(n);
    }
    props.field_count = fields.length;
    if (names.length) props.fields = names.slice(0, 15).join(',');
    return props;
  }

  function formContextText(form) {
    var parts = [textOf(form)];
    var section = form.closest && form.closest('section, article, footer, aside, div');
    if (section) parts.push(textOf(section).slice(0, 600));
    return parts.join(' ');
  }

  function hasEmailField(form) {
    return !!form.querySelector(
      'input[type="email"],input[name*="email" i],input[id*="email" i],input[placeholder*="email" i]'
    );
  }

  /**
   * A form whose ONLY real input is the email address.
   *
   * The fallback this guards exists because a bare email box is a newsletter
   * signup far more often than anything else. `hasEmailField` is not that test
   * -- it is true of any form that merely *contains* an email input, so "Book a
   * demo" (name + work email) and "Request a quote" (company + email) were both
   * being recorded as newsletter signups. That inflates the newsletter number
   * and makes demo requests vanish, which is the worse half.
   *
   * A consent checkbox is not a field a visitor fills in, so it does not count
   * against being email-only.
   */
  function isEmailOnlyForm(form) {
    var fields = toArray(form.querySelectorAll('input,select,textarea')).filter(function (el) {
      var type = (el.getAttribute('type') || el.tagName).toLowerCase();
      return type !== 'hidden' && type !== 'submit' && type !== 'button' &&
             type !== 'image' && type !== 'reset' && type !== 'checkbox';
    });
    return fields.length === 1 && hasEmailField(form);
  }

  function handleSubmit(e) {
    var form = e.target;
    if (!form || (form.tagName || '').toLowerCase() !== 'form') return;

    var manual = form.getAttribute('data-iq-event');
    if (manual) {
      emit(ruleByKey[manual], manual, mergeProps(formProps(form), { match: 'data-attribute' }));
      return;
    }

    var context = formContextText(form);
    var emailed = hasEmailField(form);
    var best = null;

    for (var r = 0; r < CONFIG.rules.length; r++) {
      var rule = CONFIG.rules[r];
      for (var t = 0; t < rule.triggers.length; t++) {
        var trigger = rule.triggers[t];
        if (trigger.type !== 'submit') continue;
        if (trigger.requiresEmail && !emailed) continue;
        if (!pageScopeAllows(trigger)) continue;

        var score = 0;
        var props = {};
        if (trigger.selector) {
          try {
            if (form.matches(trigger.selector)) { score = 100; props.match = 'selector'; }
          } catch (e2) {}
        }
        if (!score && trigger.context && trigger.context.length) {
          var phrase = bestContained(context, trigger.context);
          if (phrase) {
            score = 40 + phrase.length;
            props.match = 'form_context';
            props.matched_text = phrase;
          }
        }
        // A lone email field with no other signal is a newsletter box far more
        // often than it is anything else -- but it has to actually be lone.
        if (!score && trigger.emailOnlyFallback && isEmailOnlyForm(form)) {
          score = 20;
          props.match = 'email_field_fallback';
        }
        if (score && (!best || score > best.score)) {
          best = { rule: rule, score: score, props: props };
        }
      }
    }

    if (best) emit(best.rule, best.rule.key, mergeProps(formProps(form), best.props));
    else track('form_submit', mergeProps(formProps(form), { match: 'unclassified' }));
  }

  // ---------------------------------------------------------- pageview rules

  function pathMatches(trigger) {
    var path = normalize(location.pathname) || '/';
    if (trigger.exact && trigger.exact.length) {
      for (var i = 0; i < trigger.exact.length; i++) {
        if (path === normalize(trigger.exact[i])) return trigger.exact[i];
      }
    }
    if (trigger.path && trigger.path.length) {
      return bestContained(path, trigger.path);
    }
    return null;
  }

  function runPageviewRules() {
    for (var r = 0; r < CONFIG.rules.length; r++) {
      var rule = CONFIG.rules[r];
      for (var t = 0; t < rule.triggers.length; t++) {
        var trigger = rule.triggers[t];
        if (trigger.type !== 'pageview') continue;
        var hit = pathMatches(trigger);
        if (hit) {
          emit(rule, rule.key, { match: 'path', matched_path: hit, path: location.pathname });
          break; // one pageview event per rule per navigation
        }
      }
    }
  }

  // ------------------------------------------------- visibility ("read") rules

  var observer = null;
  var watched = [];
  var dwellTimer = null;

  function setupVisibilityRules() {
    teardownVisibility();
    if (!window.IntersectionObserver) return;

    observer = new window.IntersectionObserver(onIntersect, {
      threshold: [0, 0.25, 0.5, 0.75, 1]
    });

    for (var r = 0; r < CONFIG.rules.length; r++) {
      var rule = CONFIG.rules[r];
      for (var t = 0; t < rule.triggers.length; t++) {
        var trigger = rule.triggers[t];
        if (trigger.type !== 'visible') continue;
        if (!pageScopeAllows(trigger)) continue;

        var targets = [];
        if (trigger.selector) {
          try { targets = toArray(document.querySelectorAll(trigger.selector)); } catch (e) {}
        }
        if (!targets.length && trigger.heading) {
          var secs = sectionsMatching(trigger.heading);
          for (var s = 0; s < secs.length; s++) targets.push(secs[s].container);
        }

        for (var i = 0; i < targets.length && i < 20; i++) {
          var el = targets[i];
          if (!el || !isVisible(el)) continue;
          var entry = {
            el: el,
            rule: rule,
            trigger: trigger,
            dwell: 0,
            since: 0,
            fired: false,
            label: textOf(el).slice(0, 80)
          };
          watched.push(entry);
          el.__iqWatch = el.__iqWatch || [];
          el.__iqWatch.push(entry);
          observer.observe(el);
        }
      }
    }

    // Every heading-delimited section, in document order -- the "top to
    // bottom" half of full coverage. A rule-driven watch answers "did they
    // read the reviews"; these answer "how far down the page did they
    // actually get, and which blocks did they linger on", for sections
    // nobody thought to write a rule about.
    if (acOn('sections')) {
      var all = allSections();
      for (var s2 = 0; s2 < all.length && s2 < 60; s2++) {
        var sec = all[s2];
        if (!sec.container || !isVisible(sec.container)) continue;
        var secEntry = {
          el: sec.container,
          auto: true,
          index: s2 + 1,
          total: all.length,
          heading: sec.text.slice(0, 80),
          trigger: { visibleRatio: CONFIG.readVisibleRatio },
          dwell: 0,
          since: 0,
          fired: false,
          maxRatio: 0
        };
        watched.push(secEntry);
        sec.container.__iqWatch = sec.container.__iqWatch || [];
        sec.container.__iqWatch.push(secEntry);
        observer.observe(sec.container);
      }
    }

    // Which images were actually on screen, and for how long. An <img> in the
    // DOM proves nothing -- most of a long page is never looked at, and a
    // lazy-loaded asset below the fold may never even load.
    if (acOn('images')) {
      var imgs = toArray(document.querySelectorAll('img,picture,svg[role="img"],[data-iq-image]'));
      for (var im = 0; im < imgs.length && im < 60; im++) {
        var img = imgs[im];
        if (!isVisible(img)) continue;
        var r0 = img.getBoundingClientRect();
        // Spacers, tracking pixels and icon glyphs are not "stuff the user saw".
        if (r0.width < 48 || r0.height < 48) continue;
        var imgEntry = {
          el: img,
          image: true,
          dwell: 0,
          since: 0,
          fired: false,
          maxRatio: 0,
          trigger: { visibleRatio: CONFIG.readVisibleRatio }
        };
        watched.push(imgEntry);
        img.__iqWatch = img.__iqWatch || [];
        img.__iqWatch.push(imgEntry);
        observer.observe(img);
      }
    }

    // IntersectionObserver reports geometry changes, not the passage of time.
    // Without this ticker a section held perfectly still accumulates nothing:
    // `since` is set and checkDwell is never called again, so the event only
    // lands when the reader happens to scroll. Section exposure depends
    // entirely on elapsed time, so the ticker is not optional here.
    if (dwellTimer) window.clearInterval(dwellTimer);
    dwellTimer = window.setInterval(checkDwell, 500);
  }

  function onIntersect(entries) {
    var now = Date.now();
    for (var i = 0; i < entries.length; i++) {
      var entry = entries[i];
      var watches = entry.target.__iqWatch || [];
      for (var w = 0; w < watches.length; w++) {
        var item = watches[w];
        var ratio = item.trigger.visibleRatio || CONFIG.readVisibleRatio;
        if ((item.auto || item.image || item.product) && entry.intersectionRatio > item.maxRatio) {
          item.maxRatio = entry.intersectionRatio;
        }
        item.active = entry.intersectionRatio >= ratio;
        if (item.active) {
          // A hidden tab must not start a clock: the section is on screen in
          // layout terms, but nobody is looking at it.
          if (!item.since && !document.hidden) item.since = now;
        } else if (item.since) {
          item.dwell += now - item.since;
          item.since = 0;
        }
      }
    }
    checkDwell();
  }

  /**
   * Stop and restart the dwell clock with tab visibility.
   *
   * IntersectionObserver reports layout, not attention: a section stays fully
   * "intersecting" while the user is reading a different tab, and the ticker
   * would keep crediting that as reading time. Measured at 7.7s of "reading"
   * for 0.6s of actual reading across a 5s tab switch -- enough to make every
   * engagement number meaningless, since tabbing away mid-article is normal.
   */
  function onDwellVisibility() {
    var now = Date.now();
    for (var i = 0; i < watched.length; i++) {
      var item = watched[i];
      if (item.fired) continue;
      if (document.hidden) {
        // Bank what was genuinely read, then stop counting.
        if (item.since) { item.dwell += now - item.since; item.since = 0; }
      } else if (item.active) {
        // Back in front of them, and still on screen: resume from now.
        item.since = now;
      }
    }
  }

  function checkDwell() {
    // Nothing accumulates while the tab is in the background; onDwellVisibility
    // has already banked the time up to the moment it was hidden.
    if (document.hidden) return;
    var now = Date.now();
    for (var i = 0; i < watched.length; i++) {
      var item = watched[i];
      if (item.fired) continue;
      // Section exposure is not a threshold event -- there is no "read" to
      // declare. It is reported once per navigation, on exit or unload, with
      // however long it was actually on screen.
      if (item.auto || item.image || item.product) continue;
      var total = item.dwell + (item.since ? now - item.since : 0);
      var need = item.trigger.dwellMs || CONFIG.readDwellMs;
      if (total >= need) {
        item.fired = true;
        emit(item.rule, item.rule.key, {
          match: 'visibility',
          section: item.label,
          dwell_ms: Math.round(total)
        });
      }
    }
  }

  function flushPartialReads() {
    var now = Date.now();
    for (var i = 0; i < watched.length; i++) {
      var item = watched[i];
      if (item.fired) continue;
      var total = item.dwell + (item.since ? now - item.since : 0);

      if (item.product) {
        // Scrolled past at speed is not an impression. GA4 counts a view at
        // 50% for 1s; a card is smaller and read faster than an ad slot, so
        // the floor is lower -- but it is not zero.
        if (total < pCfg('impressionMs', 300) && item.maxRatio < 0.5) continue;
        item.fired = true;
        var ctx = autoProps(item.el, true);
        // Product metadata first: capProps truncates at maxPropertyKeys, and
        // losing the price to keep viewport_x would be the wrong trade.
        track('$product_impression', mergeProps(item.meta, {
          list_name: item.list_name,
          position: item.position,
          dwell_ms: Math.round(total),
          max_ratio: Math.round(item.maxRatio * 100) / 100,
          selector: ctx.selector,
          section: ctx.section,
          page_y: ctx.page_y,
          source: item.tier,
          match: 'autocapture'
        }));
        continue;
      }

      if (item.image) {
        if (total < 400 && item.maxRatio < 0.5) continue; // glanced past, not seen
        item.fired = true;
        var el = item.el;
        var src = el.currentSrc || el.getAttribute('src') || el.getAttribute('data-iq-image') || '';
        track('$image', mergeProps(autoProps(el), {
          image: String(src).split('?')[0].split('/').pop().slice(0, 120) || '(inline)',
          alt: (el.getAttribute('alt') || el.getAttribute('aria-label') || '').slice(0, 120),
          natural_w: el.naturalWidth || undefined,
          natural_h: el.naturalHeight || undefined,
          dwell_ms: Math.round(total),
          max_ratio: Math.round(item.maxRatio * 100) / 100,
          match: 'autocapture'
        }));
        continue;
      }

      if (item.auto) {
        // Only sections that were actually on screen. Reporting the ones
        // nobody scrolled to would drown the ones they did.
        if (total < 300 && item.maxRatio < 0.25) continue;
        item.fired = true;
        track('$section', {
          section: item.heading,
          section_index: item.index,      // 1 = topmost
          section_total: item.total,
          depth_pct: Math.round((item.index / Math.max(item.total, 1)) * 100),
          dwell_ms: Math.round(total),
          max_ratio: Math.round(item.maxRatio * 100) / 100,
          match: 'autocapture'
        });
        continue;
      }

      if (total < 500) continue; // noise
      item.fired = true;
      emit(item.rule, item.rule.key, {
        match: 'visibility',
        section: item.label,
        dwell_ms: Math.round(total),
        partial: true
      });
    }
  }

  function teardownVisibility() {
    if (dwellTimer) { window.clearInterval(dwellTimer); dwellTimer = null; }
    if (observer) { try { observer.disconnect(); } catch (e) {} }
    for (var i = 0; i < watched.length; i++) {
      if (watched[i].el) watched[i].el.__iqWatch = null;
    }
    watched = [];
    observer = null;
  }

  // -------------------------------------------------------------- baseline

  var scrollFired = {};

  function onScroll() {
    var doc = document.documentElement;
    var body = document.body;
    var height = Math.max(doc.scrollHeight, body ? body.scrollHeight : 0);
    var viewport = window.innerHeight || doc.clientHeight;
    if (height <= viewport) return;
    var scrolled = (window.pageYOffset || doc.scrollTop || 0) + viewport;
    var percent = Math.min(100, Math.round((scrolled / height) * 100));
    if (percent > maxScrollPct) maxScrollPct = percent;
    for (var i = 0; i < CONFIG.scrollDepths.length; i++) {
      var mark = CONFIG.scrollDepths[i];
      if (percent >= mark && !scrollFired[mark]) {
        scrollFired[mark] = true;
        track('scroll_depth', { percent: mark });
      }
    }
  }

  var throttled = false;
  function onScrollThrottled() {
    if (throttled) return;
    throttled = true;
    window.setTimeout(function () { throttled = false; onScroll(); }, 250);
  }

  // ------------------------------------------------------------- emit + dedup

  var fired = {};
  var navId = 0;
  var ruleByKey = {};

  function mergeProps(a, b) {
    var out = {};
    var k;
    for (k in a) if (Object.prototype.hasOwnProperty.call(a, k)) out[k] = a[k];
    for (k in b) if (Object.prototype.hasOwnProperty.call(b, k)) out[k] = b[k];
    return out;
  }

  /** Emit a rule-derived event, applying the rule's dedup policy. */
  function emit(rule, key, props) {
    var enriched = props || {};
    if (rule) {
      enriched.label = rule.label;
      enriched.category = rule.category;
      if (rule.resourceType) enriched.resource_type = rule.resourceType;
      if (rule.resourceHint) enriched.resource_hint = rule.resourceHint;
      var dedupe = rule.dedupe || 'none';
      if (dedupe !== 'none') {
        var scope = dedupe === 'session' ? 'S' : navId;
        var id = key + '|' + scope + '|' + (enriched.section || enriched.matched_path || '');
        if (fired[id]) {
          log('deduped', key);
          return;
        }
        fired[id] = true;
      }
    }
    track(key, enriched);
  }

  // ------------------------------------------------------------- navigation

  function onNavigate(isInitial) {
    navId++;
    sectionCache = null;
    scrollFired = {};
    // Dedup keys scoped to a navigation die with it; 'session' keys survive.
    var kept = {};
    for (var k in fired) {
      if (Object.prototype.hasOwnProperty.call(fired, k) && k.indexOf('|S|') !== -1) kept[k] = true;
    }
    fired = kept;

    track('page_view', mergeProps({
      referrer: document.referrer || '',
      path: location.pathname,
      initial: !!isInitial
    }, isInitial ? getAttribution() : {}));

    // A search results page is a statement of intent that no rule would catch,
    // because the term is in the query string rather than the DOM.
    var terms = CONFIG.searchParams || ['q', 's', 'query', 'search', 'keyword', 'term'];
    for (var sp = 0; sp < terms.length; sp++) {
      var term = queryParam(terms[sp]);
      if (term) {
        track('$site_search', { search_term: term.slice(0, 200), param: terms[sp], path: location.pathname });
        break;
      }
    }
    runPageviewRules();
    setupVisibilityRules();
    setupMediaTracking();
    setupProducts();
    onScroll();
  }

  // ------------------------------------------------------------- media
  //
  // "How far did they watch" has two honest answers and they routinely
  // disagree:
  //
  //   position_pct  the furthest point reached. Seeking to the end scores
  //                 100% without a second being watched.
  //   coverage_pct  which seconds actually played, counted once each.
  //                 Immune to seeking, and immune to re-watching inflating
  //                 the total past 100%.
  //
  // Both are reported. A large gap between them is the interesting signal:
  // it means people are skipping, not watching.

  var mediaSeen = [];

  function mediaName(el) {
    var src = el.currentSrc || el.getAttribute('src') || '';
    if (!src) {
      var source = el.querySelector && el.querySelector('source');
      src = (source && source.getAttribute('src')) || '';
    }
    // The basename identifies the asset; the CDN path in front of it is noise
    // that also changes whenever the bucket does.
    return String(src).split('?')[0].split('/').pop().slice(0, 120) || '(inline)';
  }

  /**
   * One shape for every player.
   *
   * A native <video> exposes currentTime directly; a YouTube or Vimeo iframe
   * only reports its position over postMessage. Keeping the accounting here,
   * off the element, means all three produce identical $video events -- so a
   * query does not have to know which player a page happened to use.
   */
  function newMediaState(kind, name, title, el) {
    return {
      kind: kind,          // 'video' | 'audio' | 'youtube' | 'vimeo'
      name: name,
      title: (title || '').slice(0, 80),
      el: el || null,
      watched: {},         // one key per whole second actually played
      milestones: {},
      seeks: 0,
      started: false,
      closed: false,
      duration: 0,
      position: 0
    };
  }

  function mediaAdvance(state, position, duration) {
    if (duration > 0) state.duration = duration;
    if (typeof position === 'number' && position >= 0) {
      state.position = position;
      state.watched[Math.floor(position)] = 1;
    }
    if (!state.duration) return;
    var pct = (state.position / state.duration) * 100;
    var marks = CONFIG.mediaMilestones || [25, 50, 75, 95];
    for (var m = 0; m < marks.length; m++) {
      if (pct >= marks[m] && !state.milestones[marks[m]]) {
        state.milestones[marks[m]] = 1;
        mediaEmit(state, 'progress', { milestone: marks[m] });
      }
    }
  }

  function mediaEmit(state, action, extra) {
    var watchedCount = 0;
    for (var k in state.watched) {
      if (Object.prototype.hasOwnProperty.call(state.watched, k)) watchedCount++;
    }
    var props = {
      media: state.name,
      media_type: state.kind,
      media_title: state.title,
      duration_s: Math.round(state.duration),
      position_s: Math.round(state.position),
      // The furthest point reached. A drag of the scrubber scores 100% here
      // without a second being watched.
      position_pct: state.duration ? Math.round((state.position / state.duration) * 100) : 0,
      // Seconds that actually played, counted once each -- immune to seeking,
      // and to re-watching pushing the total past 100.
      coverage_pct: state.duration ? Math.round((watchedCount / Math.ceil(state.duration)) * 100) : 0,
      watched_s: watchedCount,
      seeks: state.seeks || 0,
      action: action,
      match: 'autocapture'
    };
    if (state.el) {
      var sec = sectionIndexOf(state.el);
      if (sec) { props.section = sec.heading.slice(0, 80); props.section_index = sec.index; }
    }
    track('$video', mergeProps(props, extra || {}));
  }

  // ------------------------------------------------- native <video>/<audio>

  function setupNativeMedia() {
    var els = toArray(document.querySelectorAll('video,audio'));
    for (var i = 0; i < els.length && i < 20; i++) {
      (function (el) {
        if (el.__iqMedia) return; // listeners survive re-renders; do not stack them
        var state = newMediaState((el.tagName || '').toLowerCase(), mediaName(el),
          el.getAttribute('title') || el.getAttribute('aria-label'), el);
        el.__iqMedia = state;
        mediaSeen.push(state);

        function sync() {
          mediaAdvance(state, el.currentTime || 0,
            isFinite(el.duration) && el.duration > 0 ? el.duration : 0);
        }
        el.addEventListener('play', function () {
          sync();
          if (!state.started) { state.started = true; mediaEmit(state, 'play', { muted: el.muted || undefined }); }
          else mediaEmit(state, 'resume');
        });
        el.addEventListener('pause', function () {
          if (el.ended) return; // the pause a video fires as it ends is not a decision to stop
          sync();
          mediaEmit(state, 'pause');
        });
        el.addEventListener('ended', function () { sync(); mediaEmit(state, 'ended'); });
        el.addEventListener('seeked', function () { state.seeks++; });
        el.addEventListener('timeupdate', sync);
      })(els[i]);
    }
  }

  // ------------------------------------------------- YouTube / Vimeo embeds
  //
  // An embed is a cross-origin iframe: its playback state is unreadable from
  // here, and only the vendor's own postMessage protocol will report it.
  // Both are spoken directly rather than by loading the vendor's JS -- pulling
  // a third-party script into every customer page to measure a video is not a
  // trade worth making.
  //
  // YouTube ignores postMessage entirely unless the embed URL carries
  // enablejsapi=1. Adding it means reassigning src, which reloads the iframe,
  // so it is done once, at setup, before anyone has pressed play. Set
  // autocapture.embedRewrite = false to leave third-party URLs untouched and
  // accept that un-flagged YouTube embeds go unmeasured.

  var embedStates = [];
  var embedListenerBound = false;

  function embedKind(src) {
    if (/(?:youtube\.com|youtube-nocookie\.com)\/embed\//.test(src)) return 'youtube';
    if (/player\.vimeo\.com\/video\//.test(src)) return 'vimeo';
    return null;
  }

  function embedId(src, kind) {
    var m = kind === 'youtube'
      ? src.match(/\/embed\/([^/?&#]+)/)
      : src.match(/\/video\/([^/?&#]+)/);
    return (m && m[1]) || '(unknown)';
  }

  function setupEmbeddedMedia() {
    var frames = toArray(document.querySelectorAll('iframe'));
    for (var i = 0; i < frames.length && i < 10; i++) {
      (function (frame) {
        if (frame.__iqMedia) return;
        var src = frame.getAttribute('src') || '';
        var kind = embedKind(src);
        if (!kind) return;

        if (kind === 'youtube' && !/[?&]enablejsapi=1/.test(src)) {
          if (AC.embedRewrite === false) return; // opted out: nothing readable here
          src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'enablejsapi=1';
          frame.setAttribute('src', src); // reloads the iframe, hence: before playback
        }

        var state = newMediaState(kind, embedId(src, kind),
          frame.getAttribute('title') || frame.getAttribute('aria-label'), frame);
        frame.__iqMedia = state;
        state.frame = frame;
        mediaSeen.push(state);
        embedStates.push(state);

        // The handshake has to wait for the player to exist inside the frame.
        function handshake() {
          try {
            if (kind === 'youtube') {
              frame.contentWindow.postMessage(JSON.stringify({ event: 'listening', id: 1 }), '*');
              frame.contentWindow.postMessage(JSON.stringify({
                event: 'command', func: 'addEventListener', args: ['onStateChange']
              }), '*');
            } else {
              ['play', 'pause', 'ended', 'timeupdate', 'seeked'].forEach(function (name) {
                frame.contentWindow.postMessage(
                  JSON.stringify({ method: 'addEventListener', value: name }), '*');
              });
            }
          } catch (e) {}
        }
        frame.addEventListener('load', handshake);
        handshake();
        // YouTube drops the handshake if the player is not ready yet, and gives
        // no signal that it did. Retrying briefly is cheaper than missing the
        // whole session.
        var tries = 0;
        var retry = window.setInterval(function () {
          if (++tries > 6 || state.started) { window.clearInterval(retry); return; }
          handshake();
        }, 1000);
      })(frames[i]);
    }

    if (embedStates.length && !embedListenerBound) {
      embedListenerBound = true;
      window.addEventListener('message', onEmbedMessage);
    }
  }

  function onEmbedMessage(ev) {
    if (!/youtube|vimeo/.test(ev.origin || '')) return;
    var data = ev.data;
    if (typeof data === 'string') {
      try { data = JSON.parse(data); } catch (e) { return; }
    }
    if (!data || typeof data !== 'object') return;

    // Match the message to its frame: several embeds on one page is normal.
    var state = null;
    for (var i = 0; i < embedStates.length; i++) {
      try {
        if (embedStates[i].frame && embedStates[i].frame.contentWindow === ev.source) {
          state = embedStates[i];
          break;
        }
      } catch (e) {}
    }
    if (!state) return;

    // Both players announce readiness, and a handshake sent before that is
    // silently dropped. Re-sending on the announcement is what makes this
    // reliable; the retry timer is only a fallback for a `ready` that arrived
    // before the listener was bound.
    if (data.event === 'onReady' || data.event === 'ready') {
      try {
        if (state.kind === 'youtube') {
          state.frame.contentWindow.postMessage(JSON.stringify({ event: 'listening', id: 1 }), '*');
          state.frame.contentWindow.postMessage(JSON.stringify({
            event: 'command', func: 'addEventListener', args: ['onStateChange']
          }), '*');
        } else {
          ['play', 'pause', 'ended', 'timeupdate', 'seeked'].forEach(function (name) {
            state.frame.contentWindow.postMessage(
              JSON.stringify({ method: 'addEventListener', value: name }), '*');
          });
        }
      } catch (e) {}
      return;
    }

    // Vimeo echoes each addEventListener back as acknowledgement. Those carry
    // `method`, not `event`, and are not player state.
    if (data.method && !data.event) return;

    if (state.kind === 'youtube') {
      var info = data.info || {};
      if (typeof info.currentTime === 'number') {
        mediaAdvance(state, info.currentTime, info.duration || state.duration);
      }
      // playerState: 1 playing, 2 paused, 0 ended
      var ps = typeof info.playerState === 'number' ? info.playerState
        : (data.event === 'onStateChange' ? data.info : undefined);
      if (ps === 1) {
        if (!state.started) { state.started = true; mediaEmit(state, 'play'); }
        else if (state.paused) { state.paused = false; mediaEmit(state, 'resume'); }
      } else if (ps === 2 && state.started && !state.paused) {
        state.paused = true;
        mediaEmit(state, 'pause');
      } else if (ps === 0 && state.started && !state.ended) {
        state.ended = true;
        mediaEmit(state, 'ended');
      }
      return;
    }

    // Vimeo
    var d = data.data || {};
    if (data.event === 'timeupdate') {
      mediaAdvance(state, d.seconds, d.duration || state.duration);
    } else if (data.event === 'play') {
      if (!state.started) { state.started = true; mediaEmit(state, 'play'); }
      else mediaEmit(state, 'resume');
    } else if (data.event === 'pause') {
      mediaEmit(state, 'pause');
    } else if (data.event === 'ended') {
      mediaEmit(state, 'ended');
    } else if (data.event === 'seeked') {
      state.seeks++;
    }
  }

  function setupMediaTracking() {
    if (!acOn('media')) return;
    setupNativeMedia();
    if (acOn('embeds')) setupEmbeddedMedia();
  }

  /**
   * Final word on every player, on navigation or unload -- the common case is
   * someone who watches most of a video and then leaves, which emits no
   * milestone and no pause.
   */
  function flushMedia() {
    for (var i = 0; i < mediaSeen.length; i++) {
      var state = mediaSeen[i];
      if (!state.started || state.closed) continue;
      state.closed = true;
      mediaEmit(state, 'exit');
    }
    mediaSeen = [];
    embedStates = [];
  }

  // ------------------------------------------------------------- commerce
  //
  // Which products a shopper actually saw, and what they were.
  //
  // No rule can answer this. A catalogue changes daily and nobody writes an
  // event per SKU, so the spec layer is the wrong place for it. But an
  // ecommerce page already describes its own products in machine-readable
  // form -- schema.org JSON-LD, microdata, or OpenGraph product tags --
  // because Google demands it for rich results. Reading those, in that order
  // of trust, names the product and its price without one site-specific
  // selector.
  //
  //   $product_view        this page is about one product (a PDP)
  //   $product_impression  a product card was on screen, and for how long
  //
  // Listing pages routinely carry no structured data for the grid -- sites
  // mark up the PDP for Google and leave the category page bare -- so cards
  // fall back to DOM heuristics. `data-iq-product` and friends are the exact
  // override, the same escape hatch `data-iq-event` is for rules.

  var PRODUCT_CARD_SELECTOR =
    '[data-iq-product-card],[data-iq-product],[data-product-id],[data-product-sku],' +
    '[data-sku],[itemtype*="schema.org/Product"],.product-card,.product-item,' +
    '.product-tile,li.product,article.product,[class*="ProductCard"]';

  function pCfg(key, fallback) {
    var c = CONFIG.product || {};
    // null is how a config says "use the built-in", not "use nothing".
    return (c[key] === undefined || c[key] === null) ? fallback : c[key];
  }

  /** Element.closest, without assuming it exists. */
  function closestEl(el, selector) {
    var node = el;
    while (node && node.nodeType === 1) {
      if (node.closest) return node.closest(selector);
      var fn = node.matches || node.msMatchesSelector || node.webkitMatchesSelector;
      try { if (fn && fn.call(node, selector)) return node; } catch (e) { return null; }
      node = node.parentElement;
    }
    return null;
  }

  function attrOf(el, name) {
    return (el && el.getAttribute && el.getAttribute(name)) || '';
  }

  function pText(v, max) {
    if (v == null) return undefined;
    if (typeof v === 'object') v = v.name || v['@value'] || v.value || '';
    var s = String(v).replace(/\s+/g, ' ').trim();
    return s ? s.slice(0, max || 120) : undefined;
  }

  function pNum(v) {
    if (v == null || v === '') return undefined;
    var n = typeof v === 'number' ? v : parseNumber(v);
    return typeof n === 'number' && isFinite(n) ? n : undefined;
  }

  // ------------------------------------------------------------- money

  var CURRENCY_CODE = /\b(USD|EUR|GBP|INR|JPY|AUD|CAD|CHF|CNY|SEK|NZD|MXN|SGD|HKD|NOK|KRW|TRY|RUB|BRL|ZAR|AED|SAR|PLN|DKK|IDR|MYR|PHP|THB|VND|NGN|EGP|ILS|CZK|HUF|RON|UAH|ARS|CLP|COP|PEN|BDT|PKR|LKR|KES|TWD)\b/;
  var CURRENCY_SIGN = /(R\$|US\$|C\$|A\$|NZ\$|S\$|HK\$|Rs\.?|₹|\$|€|£|¥|₩|₽|₺|₪|₦|₫|฿|zł|kr)/i;
  var SIGN_TO_CODE = {
    'r$': 'BRL', 'us$': 'USD', 'c$': 'CAD', 'a$': 'AUD', 'nz$': 'NZD', 's$': 'SGD',
    'hk$': 'HKD', 'rs': 'INR', 'rs.': 'INR', '₹': 'INR', '$': 'USD', '€': 'EUR',
    '£': 'GBP', '¥': 'JPY', '₩': 'KRW', '₽': 'RUB', '₺': 'TRY', '₪': 'ILS',
    '₦': 'NGN', '₫': 'VND', '฿': 'THB', 'zł': 'PLN', 'kr': 'SEK'
  };

  /**
   * "1,299.00" and "1.299,00" are the same number written by two halves of
   * the world. Whichever separator comes last is the decimal point -- unless
   * what follows it is three digits, which makes it a thousands separator and
   * the number an integer.
   */
  function parseNumber(raw) {
    var t = String(raw).replace(/[\s '’]/g, '');
    if (!/\d/.test(t)) return null;
    t = t.replace(/[^\d.,-]/g, '');
    var cut = Math.max(t.lastIndexOf(','), t.lastIndexOf('.'));
    var out;
    if (cut === -1) out = t;
    else {
      var tail = t.slice(cut + 1);
      out = /^\d{1,2}$/.test(tail)
        ? t.slice(0, cut).replace(/[.,]/g, '') + '.' + tail
        : t.replace(/[.,]/g, '');
    }
    var n = parseFloat(out);
    return isFinite(n) ? Math.round(n * 100) / 100 : null;
  }

  /** First price-looking amount in a string, with its currency if stated. */
  function parseMoney(text) {
    if (!text) return null;
    var s = String(text).replace(/[  ]/g, ' ').slice(0, 300);
    var code = s.match(CURRENCY_CODE);
    var sign = s.match(CURRENCY_SIGN);
    var currency = code
      ? code[0].toUpperCase()
      : (sign ? SIGN_TO_CODE[sign[0].toLowerCase()] : undefined);

    // Anchor on the symbol: "From $29.99/mo" must not read the 99 or the mo.
    var mark = code || sign;
    var after = mark ? s.slice(mark.index + mark[0].length) : s;
    var m = after.match(/\d[\d.,\s]*\d|\d/);
    if (!m && mark) m = s.slice(0, mark.index).match(/\d[\d.,\s]*\d|\d/);
    if (!m) return null;
    var price = parseNumber(m[0]);
    if (price === null) return null;
    return { price: price, currency: currency };
  }

  /** "Is there a price in this string at all" -- cheaper than parsing. */
  var MONEY_TEXT = /(?:\u20b9|Rs\.?|\$|\u20ac|\u00a3|\u00a5|\u20a9)\s*\d|\d[\d,.]*\s*(?:\u20ac|\u00a3|kr|z\u0142)/i;

  var AVAILABILITY = [
    ['outofstock', 'out_of_stock'], ['soldout', 'out_of_stock'],
    ['instoreonly', 'in_store_only'], ['onlineonly', 'in_stock'],
    ['instock', 'in_stock'], ['limited', 'limited'],
    ['preorder', 'preorder'], ['presale', 'preorder'],
    ['backorder', 'backorder'], ['discontinued', 'discontinued']
  ];

  function normAvailability(v) {
    if (!v) return undefined;
    var s = String(v.name || v).toLowerCase().replace(/[^a-z]/g, '');
    for (var i = 0; i < AVAILABILITY.length; i++) {
      if (s.indexOf(AVAILABILITY[i][0]) !== -1) return AVAILABILITY[i][1];
    }
    return undefined;
  }

  // -------------------------------------------------------------- JSON-LD

  var ldCache = null;
  var ldCacheNav = -1;
  var PRODUCT_TYPE = /product|vehicle|book|softwareapplication|menuitem|course/i;

  function ldType(node) {
    var t = node && node['@type'];
    if (!t) return '';
    return (Array.isArray(t) ? t.join(' ') : String(t));
  }

  function walkLd(node, out, inList, depth) {
    if (!node || depth > 6 || out.length > 200) return;
    var i;
    if (Array.isArray(node)) {
      for (i = 0; i < node.length && i < 100; i++) walkLd(node[i], out, inList, depth + 1);
      return;
    }
    if (typeof node !== 'object') return;
    if (ldType(node)) out.push({ node: node, inList: inList });
    var keys = ['@graph', 'mainEntity', 'mainEntityOfPage', 'item', 'about'];
    for (i = 0; i < keys.length; i++) walkLd(node[keys[i]], out, inList, depth + 1);
    // Everything under an ItemList is a listing entry, never the page's subject.
    walkLd(node.itemListElement, out, true, depth + 1);
    walkLd(node.hasVariant, out, true, depth + 1);
  }

  /** Every typed JSON-LD node on the page, flagged with "was it in a list". */
  function ldNodes() {
    if (ldCache && ldCacheNav === navId) return ldCache;
    var out = [];
    var scripts = toArray(document.querySelectorAll('script[type="application/ld+json"]'));
    for (var i = 0; i < scripts.length && i < 20; i++) {
      var data = null;
      try { data = JSON.parse(scripts[i].textContent || 'null'); } catch (e) { continue; }
      walkLd(data, out, false, 0);
    }
    ldCache = out;
    ldCacheNav = navId;
    return out;
  }

  function ldProducts(inList) {
    var nodes = ldNodes();
    var out = [];
    for (var i = 0; i < nodes.length; i++) {
      if (inList !== undefined && nodes[i].inList !== inList) continue;
      if (PRODUCT_TYPE.test(ldType(nodes[i].node))) out.push(nodes[i].node);
    }
    return out;
  }

  /** An Offer, an array of them, or an AggregateOffer wrapping more. */
  function firstOffer(offers) {
    var o = Array.isArray(offers) ? offers[0] : offers;
    if (!o || typeof o !== 'object') return null;
    if (o.offers && !o.price && o.lowPrice === undefined) return firstOffer(o.offers);
    return o;
  }

  function productFromLd(node) {
    var p = {};
    p.product = pText(node.name);
    p.product_id = pText(node.sku || node.mpn || node.productID || node.gtin13 ||
                         node.gtin12 || node.gtin || node['@id'], 80);
    p.product_brand = pText(node.brand, 80);
    p.product_category = pText(node.category, 80);
    p.product_url = pText(node.url, 300);
    var img = node.image;
    if (Array.isArray(img)) img = img[0];
    p.product_image = pText(img && (img.url || img), 200);

    var offer = firstOffer(node.offers);
    if (offer) {
      var price = offer.price;
      if (price === undefined || price === null || price === '') price = offer.lowPrice;
      if (price === undefined || price === null || price === '') {
        price = offer.priceSpecification && offer.priceSpecification.price;
      }
      p.price = pNum(price);
      p.currency = pText(offer.priceCurrency ||
        (offer.priceSpecification && offer.priceSpecification.priceCurrency), 8);
      p.availability = normAvailability(offer.availability);
    }
    var rating = node.aggregateRating;
    if (rating && typeof rating === 'object') {
      p.rating = pNum(rating.ratingValue);
      p.review_count = pNum(rating.reviewCount || rating.ratingCount);
    }
    return p;
  }

  // ------------------------------------------------------------ microdata

  function mdContent(el) {
    var tag = (el.tagName || '').toLowerCase();
    var c = attrOf(el, 'content');
    if (c) return c;
    if (tag === 'meta') return '';
    if (tag === 'a' || tag === 'link' || tag === 'area') return attrOf(el, 'href');
    if (tag === 'img' || tag === 'source') return el.currentSrc || attrOf(el, 'src');
    if (tag === 'time') return attrOf(el, 'datetime') || textOf(el);
    if (tag === 'data') return attrOf(el, 'value');
    return String(el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 200);
  }

  /**
   * itemprop values belonging to `scope` -- its own, plus one level into the
   * offers/brand/rating sub-scopes it owns. Deeper than that and a related
   * product's price starts being read as this one's.
   */
  function mdProps(scope) {
    var out = {};
    var nodes = toArray(scope.querySelectorAll('[itemprop]'));
    for (var i = 0; i < nodes.length && i < 120; i++) {
      var el = nodes[i];
      var owner = el.parentElement ? closestEl(el.parentElement, '[itemscope]') : null;
      if (owner !== scope) {
        var grand = owner && owner.parentElement ? closestEl(owner.parentElement, '[itemscope]') : null;
        if (grand !== scope) continue;
      }
      var name = attrOf(el, 'itemprop');
      if (name && out[name] === undefined) out[name] = mdContent(el);
    }
    return out;
  }

  function productFromMicrodata(scope) {
    var m = mdProps(scope);
    return {
      product: pText(m.name),
      product_id: pText(m.sku || m.mpn || m.productID || m.gtin13 || m.gtin, 80),
      product_brand: pText(m.brand, 80),
      product_category: pText(m.category, 80),
      product_url: pText(m.url, 300),
      product_image: pText(m.image, 200),
      price: pNum(m.price),
      currency: pText(m.priceCurrency, 8),
      availability: normAvailability(m.availability),
      rating: pNum(m.ratingValue),
      review_count: pNum(m.reviewCount || m.ratingCount)
    };
  }

  // ---------------------------------------------------------- OpenGraph

  function metaContent(names) {
    for (var i = 0; i < names.length; i++) {
      var el = document.querySelector('meta[property="' + names[i] + '"],meta[name="' + names[i] + '"]');
      var c = el && attrOf(el, 'content');
      if (c) return c;
    }
    return '';
  }

  function productFromMeta() {
    return {
      product: pText(metaContent(['og:title', 'twitter:title']) || document.title),
      product_id: pText(metaContent(['product:retailer_item_id', 'product:sku']), 80),
      product_brand: pText(metaContent(['product:brand', 'og:brand']), 80),
      product_category: pText(metaContent(['product:category', 'article:section']), 80),
      product_url: pText(metaContent(['og:url']) || location.href, 300),
      product_image: pText(metaContent(['og:image']), 200),
      price: pNum(metaContent(['product:price:amount', 'og:price:amount', 'product:sale_price:amount'])),
      currency: pText(metaContent(['product:price:currency', 'og:price:currency']), 8),
      availability: normAvailability(metaContent(['product:availability', 'og:availability']))
    };
  }

  function hasProductMeta() {
    var type = metaContent(['og:type']);
    if (/product/i.test(type)) return true;
    return !!metaContent(['product:price:amount', 'og:price:amount']);
  }

  // ------------------------------------------------------ the page's PDP

  function nonEmpty(meta) {
    var out = {};
    for (var k in meta) {
      if (Object.prototype.hasOwnProperty.call(meta, k) &&
          meta[k] !== undefined && meta[k] !== null && meta[k] !== '') out[k] = meta[k];
    }
    return out;
  }

  function productKey(meta) {
    return (meta.product_id || '') + '|' + (meta.product || '');
  }

  /**
   * The one product this page is about, or null.
   *
   * "Exactly one" is the whole test. A category page marks up every card as a
   * Product too, and calling the first of forty a page view would make every
   * listing look like a PDP.
   */
  function detectPrimaryProduct() {
    var standalone = ldProducts(false);
    var byKey = {};
    var unique = [];
    for (var i = 0; i < standalone.length; i++) {
      var meta = nonEmpty(productFromLd(standalone[i]));
      if (!meta.product && !meta.product_id) continue;
      var key = productKey(meta);
      if (byKey[key]) continue;
      byKey[key] = true;
      unique.push(meta);
    }
    if (unique.length === 1) return { meta: unique[0], source: 'json-ld' };

    var scopes = toArray(document.querySelectorAll('[itemscope][itemtype*="schema.org/Product"]'));
    var outer = [];
    for (var s = 0; s < scopes.length; s++) {
      if (scopes[s].parentElement &&
          closestEl(scopes[s].parentElement, '[itemtype*="schema.org/Product"]')) continue;
      outer.push(scopes[s]);
    }
    if (outer.length === 1) {
      var md = nonEmpty(productFromMicrodata(outer[0]));
      if (md.product || md.product_id) {
        md.__el = outer[0];
        return { meta: md, source: 'microdata' };
      }
    }

    if (hasProductMeta()) {
      var og = nonEmpty(productFromMeta());
      if (og.product && (og.price !== undefined || og.product_id)) {
        return { meta: og, source: 'opengraph' };
      }
    }

    // Tier 2: this page's own URL says it is one product's page. True on
    // every marketplace PDP, none of which publish JSON-LD reliably.
    var own = productFromUrl(location.href);
    if (own) {
      var meta = nonEmpty(own);
      // The page's own price, read the same way a card's is.
      var host = document.querySelector('main,[role=main],#dp,#container') || document.body;
      if (host) {
        var money = cardPrice(host);
        if (money) {
          meta.price = money.price;
          if (money.list_price !== undefined) meta.list_price = money.list_price;
          if (money.discount_pct !== undefined) meta.discount_pct = money.discount_pct;
          meta.currency = meta.currency || pText(money.currency, 8);
        }
      }
      var h1 = document.querySelector('h1');
      if (h1 && textOf(h1)) meta.product = pText(String(h1.textContent).replace(/\s+/g, ' ').trim());
      return { meta: meta, source: 'url' };
    }
    return null;
  }

  // ------------------------------------------------------- URL grammar
  //
  // The discriminator the DOM does not carry.
  //
  // On a marketplace homepage, a promo tile and a product card are the same
  // markup: a link, an image, and a price. Amazon's homepage has 25 such
  // blocks reading "Starting Rs.149 | Kettles" and pointing at /s?... -- emit
  // those as products and the catalogue fills with forty fake SKUs a page.
  // What separates them is the shape of the href, so every structural guess
  // below is gated on it.

  //
  // Deliberately path-only. Flipkart hangs `?pid=` on its "Cash on Delivery"
  // and "Protect Promise Fee" links too, so a query parameter alone admits
  // every piece of page furniture as a product. Params still supply the id
  // once the path has qualified the link.
  var PDP_URL = /\/(?:dp|gp\/product|p|products?|item|itm|pd|buy|listing)\/|\/itm[0-9a-z]{6,}/i;
  var LIST_URL = /\/(?:s|b|search|browse|category|categories|c|collections?|shop|deals|sale|gp\/browse|gp\/bestsellers)[/?]|[?&](?:k|q|field-keywords|node|bbn|category)=/i;

  /**
   * Platform adapters -- tier 2.
   *
   * Twenty entries covers most of what a customer will ever point this at,
   * and each is a URL grammar rather than a selector, so a redesign does not
   * break it. `id` and `variant` are capture groups; `name` is the slug.
   */
  var ADAPTERS = [
    { key: 'amazon',    host: /(^|\.)amazon\./i,
      pdp: /\/(?:dp|gp\/product)\/[A-Z0-9]{10}/,
      id: /\/(?:dp|gp\/product)\/([A-Z0-9]{10})/, name: /^\/([^/?]+)\/(?:dp|gp)\// },
    { key: 'flipkart',  host: /(^|\.)flipkart\./i,
      pdp: /\/p\/itm[0-9a-z]+/i,
      id: /\/p\/(itm[0-9a-z]+)/i, variant: /[?&]pid=([A-Z0-9]+)/i, name: /^\/([^/?]+)\/p\// },
    { key: 'shopify',   host: null,
      pdp: /\/products\/[^/?#]+/,
      id: /\/products\/([^/?#]+)/, name: /\/products\/([^/?#]+)/, variant: /[?&]variant=(\d+)/ },
    { key: 'ebay',      host: /(^|\.)ebay\./i, pdp: /\/itm\/\d+/, id: /\/itm\/(\d+)/ },
    { key: 'myntra',    host: /(^|\.)myntra\./i, pdp: /\/\d+\/buy/, id: /\/(\d+)\/buy/, name: /^\/([^/?]+)\// },
    { key: 'ajio',      host: /(^|\.)ajio\./i, pdp: /\/p\/[0-9a-z_]+/i, id: /\/p\/([0-9a-z_]+)/i, name: /^\/([^/?]+)\/p\// },
    { key: 'meesho',    host: /(^|\.)meesho\./i, pdp: /\/p\/[0-9a-z]+/i, id: /\/p\/([0-9a-z]+)/i, name: /^\/([^/?]+)\/p\// },
    { key: 'nykaa',     host: /(^|\.)nykaa\./i, pdp: /\/p\/\d+/, id: /\/p\/(\d+)/, name: /^\/([^/?]+)\/p\// },
    { key: 'woocommerce', host: null, pdp: /\/product\/[^/?#]+/,
      id: /\/product\/([^/?#]+)/, name: /\/product\/([^/?#]+)/ }
  ];

  var adapterCache;

  /** The adapter for this site, or null. Host match first, then URL shape. */
  function adapterFor() {
    if (adapterCache !== undefined) return adapterCache;
    adapterCache = null;
    var host = location.hostname;
    var i;
    for (i = 0; i < ADAPTERS.length; i++) {
      if (ADAPTERS[i].host && ADAPTERS[i].host.test(host)) { adapterCache = ADAPTERS[i]; return adapterCache; }
    }
    // Host-agnostic platforms (Shopify, Woo) are recognised by their URL
    // grammar appearing on the page at all -- a store on its own domain.
    for (i = 0; i < ADAPTERS.length; i++) {
      var a = ADAPTERS[i];
      if (a.host || !a.id) continue;
      if (a.id.test(location.pathname)) { adapterCache = a; return adapterCache; }
      try {
        if (document.querySelector('a[href*="' + (a.key === 'shopify' ? '/products/' : '/product/') + '"]')) {
          adapterCache = a; return adapterCache;
        }
      } catch (e) {}
    }
    return adapterCache;
  }

  function deslug(s) {
    return String(s || '')
      .replace(/\.(html?|php|aspx?)$/i, '')
      .replace(/[-_+]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 120);
  }

  /** Is this href a link to one product, rather than to a list of them? */
  function isProductHref(raw) {
    if (!raw) return false;
    var path;
    try {
      var u = new URL(raw, location.href);
      if (u.hostname !== location.hostname) return false; // an ad, not the catalogue
      path = u.pathname + u.search;
    } catch (e) { return false; }
    // A matched platform knows its own grammar; the generic union is only
    // for sites no adapter claimed.
    var ad = adapterFor();
    if (ad && ad.pdp) return ad.pdp.test(path);
    if (LIST_URL.test(path) && !PDP_URL.test(path)) return false;
    return PDP_URL.test(path);
  }

  /**
   * Identity from a URL alone -- tier 4, and the name source for tiers 2-3.
   *
   * Flipkart's every tile carries alt="Image", so the slug is the only place
   * a product name exists on that page. It also carries the variant: the
   * path holds while `pid` moves across colour and storage.
   */
  function productFromUrl(raw) {
    var url;
    try { url = new URL(raw, location.href); } catch (e) { return null; }
    var full = url.pathname + url.search;
    var ad0 = adapterFor();
    if (ad0 && ad0.pdp) { if (!ad0.pdp.test(full)) return null; }
    else if (!PDP_URL.test(full)) return null;

    var out = { product_url: pText(url.href, 300) };
    var ad = adapterFor();
    var m;
    if (ad) {
      if (ad.id && (m = full.match(ad.id))) out.product_id = pText(m[1], 80);
      if (ad.variant && (m = full.match(ad.variant))) out.product_variant = pText(m[1], 80);
      if (ad.name && (m = url.pathname.match(ad.name))) out.product = pText(deslug(m[1]));
      out.platform = ad.key;
    }
    if (!out.product_id) {
      m = full.match(/[?&](?:pid|sku|productId|product_id|asin|itemId)=([^&#]+)/i);
      if (m) out.product_id = pText(decodeURIComponent(m[1]), 80);
    }
    if (!out.product_id) {
      // The last meaningful path segment, when it is not the marker itself.
      var segs = url.pathname.split('/').filter(Boolean);
      var last = segs[segs.length - 1] || '';
      if (last && !/^(p|dp|product|products|item|itm|buy)$/i.test(last)) out.product_id = pText(last, 80);
    }
    if (!out.product) {
      var parts = url.pathname.split('/').filter(Boolean);
      // The longest hyphenated segment is the slug on every grammar seen.
      var best = '';
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].indexOf('-') !== -1 && parts[i].length > best.length) best = parts[i];
      }
      if (best) out.product = pText(deslug(best));
    }
    return (out.product || out.product_id) ? out : null;
  }

  // ------------------------------------------------------------- cards

  var PRICE_SELECTOR = '[itemprop="price"],[data-price],[class*="price" i],[class*="Price"]';

  function ldMatching(url, name) {
    var listed = ldProducts(undefined);
    var wantName = normalize(name);
    var wantPath = '';
    try { if (url) wantPath = new URL(url, location.href).pathname; } catch (e) {}
    for (var i = 0; i < listed.length; i++) {
      var meta = productFromLd(listed[i]);
      if (wantName && normalize(meta.product) === wantName) return meta;
      if (wantPath && meta.product_url) {
        var p = '';
        try { p = new URL(meta.product_url, location.href).pathname; } catch (e) {}
        if (p && p === wantPath) return meta;
      }
    }
    return null;
  }

  function cardName(el) {
    var explicit = attrOf(el, 'data-iq-product') || attrOf(el, 'data-product-name') ||
                   attrOf(el, 'data-name') || attrOf(el, 'data-title');
    if (explicit) return explicit;
    var probe = el.querySelector(
      '[itemprop="name"],[data-product-title],.product-title,.product-name,' +
      '[class*="ProductTitle"],[class*="product-title"],h1,h2,h3,h4');
    var name = probe ? String(probe.textContent || '').replace(/\s+/g, ' ').trim() : '';
    if (!name) {
      var img = el.querySelector('img[alt]');
      name = img ? attrOf(img, 'alt') : '';
    }
    if (!name) {
      var link = el.matches && el.matches('a[href]') ? el : el.querySelector('a[href]');
      name = link ? String(link.textContent || '').replace(/\s+/g, ' ').trim() : '';
    }
    return name;
  }

  /**
   * Is this node the crossed-out original rather than the price being asked?
   *
   * Flipkart renders both adjacent, so a card's raw text reads
   * "Rs.11,999Rs.9,972" and the first number found is the MRP -- read that as
   * the price and every discount metric inverts. Nothing names these nodes:
   * across 34 of them the only marker is the computed decoration.
   */
  function isStruck(el) {
    try {
      var cs = window.getComputedStyle(el);
      if (cs && /line-through/.test(cs.textDecorationLine || cs.textDecoration || '')) return true;
    } catch (e) {}
    var tag = (el.tagName || '').toLowerCase();
    if (tag === 's' || tag === 'del' || tag === 'strike') return true;
    // jsdom and older engines report no computed decoration; the inline
    // style is what Flipkart actually ships.
    if (/line-through/.test(attrOf(el, 'style'))) return true;
    return /\b(mrp|strike|struck|was-price|old-price|list-price|compare-at)\b/i.test(attrOf(el, 'class'));
  }

  /**
   * A placeholder rather than a product name.
   *
   * Flipkart's every tile carries alt="Image"; other themes ship "product",
   * "thumbnail" or the bare index. Any of them beaten by the URL slug.
   */
  function isGenericName(name) {
    if (!name) return true;
    var n = normalize(name);
    if (n.length < 4) return true;
    return /^(image|img|photo|picture|thumbnail|thumb|product|item|banner|logo|icon|\d+)$/.test(n);
  }

  function cardPrice(el) {
    var explicit = attrOf(el, 'data-iq-price') || attrOf(el, 'data-price') ||
                   attrOf(el, 'data-product-price');
    if (explicit) {
      var direct = parseMoney(explicit) || { price: pNum(explicit) };
      if (direct && direct.price !== undefined && direct.price !== null) {
        return {
          price: direct.price,
          currency: direct.currency || attrOf(el, 'data-iq-currency') ||
                    attrOf(el, 'data-currency') || undefined
        };
      }
    }
    // A price node first: the card's full text also contains ratings, badges
    // and "2 left", any of which parse as a number.
    var nodes = [];
    try { nodes = toArray(el.querySelectorAll(PRICE_SELECTOR)); } catch (e) {}
    if (!nodes.length) nodes = moneyNodes(el);

    var asked = null;
    var struck = null;
    for (var i = 0; i < nodes.length && i < 12; i++) {
      var n = nodes[i];
      var money = parseMoney(attrOf(n, 'content') || attrOf(n, 'data-price') || n.textContent);
      if (!money) continue;
      if (isStruck(n)) { if (!struck) struck = money; }
      else if (!asked) asked = money;
    }
    if (asked) {
      if (struck && struck.price > asked.price) {
        asked.list_price = struck.price;
        asked.discount_pct = Math.round((1 - asked.price / struck.price) * 100);
      }
      return asked;
    }
    if (struck) return struck;
    return parseMoney(el.textContent);
  }

  /**
   * Leaf-ish descendants whose own text is a price.
   *
   * The cap is on what is returned, not on how far it looks: a marketplace
   * page puts several thousand nodes of chrome above the first product, and
   * capping the scan means never reaching the grid at all.
   */
  function moneyNodes(el, limit) {
    var out = [];
    var all;
    try { all = toArray(el.querySelectorAll('*')); } catch (e) { return out; }
    var max = limit || 400;
    var hits = [];
    for (var i = 0; i < all.length && hits.length < max * 2; i++) {
      var n = all[i];
      if (n.children.length > 2) continue;
      var t = String(n.textContent || '').trim();
      if (t.length < 60 && MONEY_TEXT.test(t)) hits.push(n);
    }
    // Innermost only. Flipkart wraps its struck MRP and its asking price in
    // one div, so the wrapper's text reads "Rs.11,999Rs.9,972" -- collected
    // first in document order, not struck, and parsed as a price of 11,999
    // when the product actually costs 9,972.
    for (var h = 0; h < hits.length && out.length < max; h++) {
      var enclosing = false;
      for (var j = 0; j < hits.length; j++) {
        if (j !== h && hits[h].contains(hits[j])) { enclosing = true; break; }
      }
      if (!enclosing) out.push(hits[h]);
    }
    return out;
  }

  /**
   * Card metadata, memoised for the life of the navigation.
   *
   * autoProps asks for this on every click, image flush and copy, and the
   * answer cannot change without the DOM changing -- at which point the
   * rescan re-reads it anyway.
   */
  function productFromCard(el) {
    if (el.__iqProductMeta && el.__iqProductMetaNav === navId) return el.__iqProductMeta;
    var meta = readCard(el);
    el.__iqProductMeta = meta;
    el.__iqProductMetaNav = navId;
    return meta;
  }

  function readCard(el) {
    var meta = {};
    if (attrOf(el, 'itemtype').indexOf('schema.org/Product') !== -1) {
      meta = nonEmpty(productFromMicrodata(el));
    }

    var name = meta.product || cardName(el);
    var link = null;
    try {
      link = (el.matches && el.matches('a[href]')) ? el : el.querySelector('a[href]');
    } catch (e) {}
    if (!link && el.tagName === 'A') link = el;
    var href = meta.product_url || (link ? attrOf(link, 'href') : '');

    // A listing page whose grid carries no markup often still ships an
    // ItemList in JSON-LD; match on it before falling back to the DOM.
    var ld = ldMatching(href, name);
    if (ld) meta = mergeProps(nonEmpty(ld), meta);

    var fromUrl = href ? productFromUrl(href) : null;
    if (!meta.product && name) meta.product = pText(name);
    if (!meta.product_id) {
      meta.product_id = pText(attrOf(el, 'data-iq-product-id') || attrOf(el, 'data-product-id') ||
                              attrOf(el, 'data-product-sku') || attrOf(el, 'data-sku') ||
                              attrOf(el, 'data-id'), 80);
    }
    if (!meta.product_brand) {
      meta.product_brand = pText(attrOf(el, 'data-iq-brand') || attrOf(el, 'data-brand'), 80);
    }
    if (!meta.product_category) {
      meta.product_category = pText(attrOf(el, 'data-iq-category') || attrOf(el, 'data-category'), 80);
    }
    // The URL is the last identity source, never the first: a site that
    // annotated its markup said what it meant, and a slug is inference.
    // It is still the only name on a site whose every tile ships alt="Image".
    if (fromUrl) {
      if (!meta.product_id) meta.product_id = fromUrl.product_id;
      if (!meta.product_variant) meta.product_variant = fromUrl.product_variant;
      if (!meta.platform) meta.platform = fromUrl.platform;
      if (fromUrl.product && (!meta.product || isGenericName(meta.product))) {
        meta.product = fromUrl.product;
      }
    }

    if (meta.price === undefined) {
      var money = cardPrice(el);
      if (money) {
        meta.price = money.price;
        if (money.list_price !== undefined) meta.list_price = money.list_price;
        if (money.discount_pct !== undefined) meta.discount_pct = money.discount_pct;
        if (!meta.currency) meta.currency = pText(money.currency, 8);
      }
    }
    if (!meta.product_url && href) {
      try { meta.product_url = pText(new URL(href, location.href).href, 300); } catch (e) {}
    }
    if (!meta.product_image) {
      var img = el.querySelector('img');
      if (img) meta.product_image = pText(img.currentSrc || attrOf(img, 'src'), 200);
    }
    return nonEmpty(meta);
  }

  /** Innermost matches only: a grid wrapper is not itself a card. */
  function namedProductCards() {
    var selector = pCfg('cardSelector', PRODUCT_CARD_SELECTOR);
    var all = [];
    try { all = toArray(document.querySelectorAll(selector)); } catch (e) { return []; }
    var out = [];
    for (var i = 0; i < all.length && i < 300; i++) {
      var el = all[i];
      var nested = false;
      try { nested = !!el.querySelector(selector); } catch (e) {}
      if (nested) continue;
      out.push(el);
    }
    return out;
  }

  /**
   * A card's structural signature -- deliberately class-free.
   *
   * Class names are the one thing a build tool rewrites, so grouping on them
   * fails on exactly the sites that need this tier. Ancestor tag chain plus
   * child tag shape survives a rename and still tells two components apart.
   */
  function cardSignature(el) {
    var chain = [];
    var n = el;
    for (var i = 0; i < 3 && n && n.nodeType === 1; i++) { chain.push(n.tagName); n = n.parentElement; }
    var kids = [];
    for (var k = 0; k < el.children.length && k < 6; k++) kids.push(el.children[k].tagName);
    return chain.join('<') + '|' + kids.join(',');
  }

  /** The nearest ancestor that looks like a whole card, not a fragment. */
  function cardContainerOf(el) {
    var n = el;
    for (var d = 0; d < 8 && n && n.nodeType === 1; d++) {
      if (n.querySelector && n.querySelector('a[href]') && n.querySelector('img')) return n;
      n = n.parentElement;
    }
    return null;
  }

  /**
   * Tier 3: repeating structure, gated on the href.
   *
   * Find every block whose own text is a price, walk up to its card, group
   * the cards by signature, and keep a group only if it repeats and its
   * members link to product pages. The gate is what stops a homepage's
   * category promos -- same markup, same price-shaped text -- from being
   * reported as products.
   */
  function inferredProductCards() {
    var prices = moneyNodes(document.body || document.documentElement);
    var groups = {};
    var order = [];
    // Scoped to this call: the scan runs again on every rescan, and a flag
    // stored on the element would make the second pass find nothing.
    var seenCard = [];
    for (var i = 0; i < prices.length && i < 400; i++) {
      var card = cardContainerOf(prices[i]);
      if (!card || seenCard.indexOf(card) !== -1) continue;
      seenCard.push(card);
      var link = card.querySelector('a[href]');
      if (!link || !isProductHref(link.getAttribute('href'))) continue;
      var sig = cardSignature(card);
      if (!groups[sig]) { groups[sig] = []; order.push(sig); }
      groups[sig].push(card);
    }
    var out = [];
    for (var g = 0; g < order.length; g++) {
      var items = groups[order[g]];
      // One match is a coincidence; a component is used more than once.
      if (items.length >= 3) out = out.concat(items);
    }
    return out;
  }

  /** Tier 4: a product-shaped link and nothing else around it. */
  function linkOnlyProducts() {
    var out = [];
    var links;
    try { links = toArray(document.querySelectorAll('a[href]')); } catch (e) { return out; }
    var seen = {};
    for (var i = 0; i < links.length && i < 400 && out.length < 60; i++) {
      var href = links[i].getAttribute('href');
      if (!isProductHref(href)) continue;
      var meta = productFromUrl(href);
      if (!meta) continue;
      var key = meta.product_id || meta.product;
      if (seen[key]) continue;
      seen[key] = true;
      out.push(links[i]);
    }
    return out;
  }

  /**
   * Cards for this page, best tier first.
   *
   * Stops at the first tier that finds anything: a site with real markup
   * never pays for the guessing, and a site with none still reports.
   */
  function findProductCards() {
    var named = namedProductCards();
    if (named.length) { productTier = named.length ? 'markup' : null; return named; }
    var inferred = inferredProductCards();
    if (inferred.length) { productTier = 'structure'; return inferred; }
    var links = linkOnlyProducts();
    if (links.length) { productTier = 'link'; return links; }
    productTier = null;
    return [];
  }

  function productListName(el) {
    var node = el.parentElement;
    var depth = 0;
    while (node && depth < 4) {
      var label = attrOf(node, 'aria-label') || attrOf(node, 'data-list-name') ||
                  attrOf(node, 'data-iq-list');
      if (label) return pText(label, 80);
      node = node.parentElement;
      depth++;
    }
    var sec = sectionIndexOf(el);
    return sec ? pText(sec.heading, 80) : undefined;
  }

  // ----------------------------------------------------------- lifecycle

  var productTimers = [];
  var productTier = null;
  var productPrimary = null;
  var productSeen = {};
  var productWatched = 0;

  function setupProducts() {
    for (var t = 0; t < productTimers.length; t++) window.clearTimeout(productTimers[t]);
    productTimers = [];
    productPrimary = null;
    productSeen = {};
    productWatched = 0;
    ldCache = null;
    if (!acOn('products')) return;

    scanProducts(navId);

    // An ecommerce SPA renders its grid after the route change, and a PDP's
    // JSON-LD often arrives with the same fetch. One scan at navigation time
    // would see an empty page on most of them.
    var delays = pCfg('rescanMs', [800, 2500]);
    for (var d = 0; d < delays.length && d < 5; d++) {
      (function (ms, nav) {
        productTimers.push(window.setTimeout(function () {
          if (nav !== navId) return;
          scanProducts(nav);
        }, ms));
      })(delays[d], navId);
    }
  }

  function scanProducts(nav) {
    if (nav !== navId || !acOn('products')) return;
    ldCache = null; // late-injected JSON-LD is the common case, not the rare one

    if (!productPrimary) {
      var primary = detectPrimaryProduct();
      if (primary) {
        productPrimary = primary;
        productSeen[productKey(primary.meta)] = true;
        var props = nonEmpty(primary.meta);
        delete props.__el;
        track('$product_view', mergeProps(props, {
          source: primary.source,
          path: location.pathname,
          match: 'autocapture'
        }));
      }
    }
    watchProductCards();
  }

  function watchProductCards() {
    if (!observer) return;
    var max = pCfg('maxCards', 40);
    if (productWatched >= max) return;
    var cards = findProductCards();
    var primaryEl = productPrimary && productPrimary.meta && productPrimary.meta.__el;

    for (var i = 0; i < cards.length && productWatched < max; i++) {
      var el = cards[i];
      if (el.__iqProductNav === navId) continue;
      el.__iqProductNav = navId;
      if (el === primaryEl || !isVisible(el)) continue;
      var r = el.getBoundingClientRect();
      if (r.width < 40 || r.height < 40) continue; // a chip, not a card

      var meta = productFromCard(el);
      if (!meta.product && !meta.product_id) continue;
      var key = productKey(meta);
      if (productSeen[key]) continue;   // the PDP's own product, or a repeat
      productSeen[key] = true;

      var entry = {
        el: el,
        product: true,
        meta: meta,
        tier: productTier,
        list_name: productListName(el),
        position: i + 1,
        dwell: 0,
        since: 0,
        fired: false,
        maxRatio: 0,
        trigger: { visibleRatio: pCfg('impressionRatio', CONFIG.readVisibleRatio) }
      };
      watched.push(entry);
      el.__iqWatch = el.__iqWatch || [];
      el.__iqWatch.push(entry);
      observer.observe(el);
      productWatched++;
    }
    if (productWatched) log('products: watching ' + productWatched + ' card(s)');
  }

  /**
   * The product a click, image or copy happened inside -- identity only.
   *
   * Enough to answer "which product were they looking at when they did that"
   * without emitting a second event per interaction, which is the same trade
   * the click autocapture already makes.
   */
  function productContext(el) {
    if (!acOn('products') || !el) return null;
    var card = null;
    try { card = closestEl(el, pCfg('cardSelector', PRODUCT_CARD_SELECTOR)); } catch (e) {}
    var meta = null;
    if (card) meta = productFromCard(card);
    else if (productPrimary) meta = productPrimary.meta;
    if (!meta || (!meta.product && !meta.product_id)) return null;
    return {
      product: meta.product,
      product_id: meta.product_id,
      price: meta.price,
      currency: meta.currency
    };
  }

  /** What the runtime currently believes is on the page. Debugging aid. */
  function productReport() {
    var cards = findProductCards();
    var rows = [];
    for (var i = 0; i < cards.length && i < 100; i++) {
      var meta = productFromCard(cards[i]);
      if (!meta.product && !meta.product_id) continue;
      rows.push({
        product: meta.product,
        product_id: meta.product_id,
        price: meta.price,
        list_price: meta.list_price,
        currency: meta.currency,
        variant: meta.product_variant,
        position: i + 1,
        selector: cssPath(cards[i])
      });
    }
    return {
      pdp: productPrimary ? { source: productPrimary.source, product: productPrimary.meta.product } : null,
      tier: productTier,
      platform: (adapterFor() || {}).key || null,
      cards: rows
    };
  }

  // ------------------------------------------------- choices and variants
  //
  // "Which option did they pick" cannot be built on <select>.
  //
  // Across 3.9 MB of two marketplace homepages there is exactly one real
  // native dropdown: Amazon's search-category picker. Nine of its ten
  // <select> elements are video-player caption settings, and Flipkart ships
  // none at all -- nor any aria-expanded, aria-selected or role="listbox".
  // Every size, colour and storage picker on those sites is untyped divs.
  //
  // So this is four layers, and only the first two are certain:
  //
  //   native   change on select/radio/checkbox      $field_change
  //   aria     aria-expanded/selected/checked flips $ui_choice
  //   url      a query parameter moves in place     $product_variant_change
  //   commit   a click, then the price or title changed
  //
  // The last is the only one that catches a fully custom picker, and it is a
  // heuristic: it says "an option was chosen" because the page reacted like
  // one was, not because the markup said so.

  var CHOICE_ATTRS = ['aria-expanded', 'aria-selected', 'aria-checked', 'aria-current'];

  /** The visible label for a control, never the value the user typed. */
  function controlLabel(el) {
    var id = attrOf(el, 'id');
    var lab = '';
    if (id) {
      try {
        var forEl = document.querySelector('label[for="' + id.replace(/"/g, '\\"') + '"]');
        if (forEl) lab = textOf(forEl);
      } catch (e) {}
    }
    if (!lab) {
      var wrap = closestEl(el, 'label');
      if (wrap) lab = textOf(wrap);
    }
    if (!lab) lab = normalize(attrOf(el, 'aria-label') || attrOf(el, 'placeholder') ||
                             attrOf(el, 'name') || attrOf(el, 'id'));
    return pText(lab, 80);
  }

  /**
   * What a select is currently showing.
   *
   * The option's text, not its value: a value is an opaque id on half the
   * sites in existence, and on the other half it is a SKU nobody can read.
   */
  function selectedLabel(el) {
    try {
      var tag = (el.tagName || '').toLowerCase();
      if (tag === 'select') {
        var opt = el.options && el.options[el.selectedIndex];
        return opt ? pText(String(opt.textContent || opt.value).replace(/\s+/g, ' ').trim(), 80) : undefined;
      }
      if (el.type === 'checkbox') return el.checked ? 'checked' : 'unchecked';
      if (el.type === 'radio') return controlLabel(el) || pText(el.value, 80);
    } catch (e) {}
    return undefined;
  }

  function setupNativeChoices() {
    document.addEventListener('change', function (ev) {
      var el = ev.target;
      if (!el || !el.tagName) return;
      var tag = el.tagName.toLowerCase();
      var type = (el.getAttribute('type') || '').toLowerCase();
      if (tag !== 'select' && type !== 'radio' && type !== 'checkbox') return;
      if (type === 'password') return;

      track('$field_change', mergeProps(autoProps(el), {
        control: tag === 'select' ? 'select' : type,
        field_name: pText(attrOf(el, 'name') || attrOf(el, 'id') || controlLabel(el), 60),
        label: controlLabel(el),
        choice: selectedLabel(el),
        options: tag === 'select' && el.options ? el.options.length : undefined,
        match: 'native'
      }));
    }, true);
  }

  /**
   * Custom pickers that at least announce themselves through ARIA.
   *
   * Correct wherever it applies, which on the two captures reviewed is
   * nowhere -- but it is free on the sites that do it properly, and those
   * are the ones whose data would otherwise look identical to a site with
   * no picker at all.
   */
  function setupAriaChoices() {
    if (!window.MutationObserver) return;
    var seen = {};
    var obs = new window.MutationObserver(function (records) {
      for (var i = 0; i < records.length && i < 40; i++) {
        var r = records[i];
        var el = r.target;
        if (!el || el.nodeType !== 1) continue;
        var name = r.attributeName;
        var now = el.getAttribute(name);
        if (now === r.oldValue) continue;

        if (name === 'aria-expanded') {
          if (now !== 'true') continue;            // opening is the intent; closing is noise
          track('$ui_choice', mergeProps(autoProps(el), {
            control: 'disclosure', action: 'open',
            label: pText(textOf(el) || attrOf(el, 'aria-label'), 80),
            match: 'aria'
          }));
          continue;
        }
        if (now !== 'true') continue;              // selected/checked/current turning on
        var key = cssPath(el) + '|' + name;
        if (seen[key] === navId) continue;         // a re-render is not a re-choice
        seen[key] = navId;
        track('$ui_choice', mergeProps(autoProps(el), {
          control: name === 'aria-checked' ? 'toggle' : 'option',
          action: 'select',
          choice: pText(textOf(el) || attrOf(el, 'aria-label'), 80),
          label: pText(groupLabelOf(el), 80),
          match: 'aria'
        }));
      }
    });
    try {
      obs.observe(document.documentElement, {
        subtree: true, attributes: true, attributeOldValue: true, attributeFilter: CHOICE_ATTRS
      });
    } catch (e) {}
  }

  /** The heading or aria-label of the group an option belongs to. */
  function groupLabelOf(el) {
    var node = el.parentElement;
    for (var d = 0; d < 4 && node; d++) {
      var lab = attrOf(node, 'aria-label') || attrOf(node, 'data-iq-choice-group');
      if (lab) return lab;
      var head = node.querySelector && node.querySelector('legend,h2,h3,h4,label');
      if (head && !head.contains(el)) return textOf(head);
      node = node.parentElement;
    }
    return '';
  }

  /**
   * The variant picker every marketplace actually ships.
   *
   * On Flipkart the path holds while `pid` moves: /realme-p4s-5g-…/p/itm…
   * is the product and ?pid=MOBH… is the colour and storage. So a variant
   * change is a query-string change without a path change -- visible to the
   * history patch, invisible to every DOM-based approach.
   */
  var lastVariantKey = null;
  var VARIANT_PARAMS = /^(pid|variant|sku|size|color|colour|style|option|selected)/i;

  function variantKey() {
    var out = [];
    try {
      var qs = location.search.replace(/^\?/, '').split('&');
      for (var i = 0; i < qs.length; i++) {
        var kv = qs[i].split('=');
        if (kv[0] && VARIANT_PARAMS.test(kv[0])) out.push(kv[0] + '=' + (kv[1] || ''));
      }
    } catch (e) {}
    return out.sort().join('&');
  }

  function checkVariantChange(prevPath) {
    var key = variantKey();
    var samePath = prevPath === location.pathname;
    if (samePath && lastVariantKey !== null && key !== lastVariantKey && key) {
      var meta = productPrimary ? productPrimary.meta : (productFromUrl(location.href) || {});
      track('$product_variant_change', mergeProps(nonEmpty({
        product: meta.product,
        product_id: meta.product_id,
        price: meta.price,
        currency: meta.currency
      }), {
        variant_from: pText(lastVariantKey, 120),
        variant_to: pText(key, 120),
        path: location.pathname,
        match: 'url'
      }));
    }
    lastVariantKey = key;
  }

  /**
   * A choice nobody declared: a click in a group of siblings, followed by
   * the page's own price or title changing.
   *
   * That pairing is what selecting a variant *is*, whatever it was built
   * from. The 700ms window is the outer edge of a client-side re-render;
   * beyond it the change is more likely a fetch the user did not cause.
   */
  var commitWatch = null;

  function watchForCommit(el) {
    if (!acOn('choices') || !el) return;
    var group = el.parentElement;
    if (!group || group.children.length < 3) return;     // not one of a set
    var before = pageChoiceFingerprint();
    if (commitWatch) window.clearTimeout(commitWatch);
    commitWatch = window.setTimeout(function () {
      commitWatch = null;
      var after = pageChoiceFingerprint();
      if (after === before) return;                       // nothing reacted: an ordinary click
      track('$ui_choice', mergeProps(autoProps(el), {
        control: 'custom',
        action: 'select',
        choice: pText(textOf(el) || attrOf(el, 'title') || attrOf(el, 'aria-label'), 80),
        label: pText(groupLabelOf(el), 80),
        siblings: group.children.length,
        match: 'inferred'
      }));
    }, pCfg('commitMs', 700));
  }

  /** Price and title, the two things a variant selection moves. */
  function pageChoiceFingerprint() {
    var parts = [];
    try {
      var h1 = document.querySelector('h1');
      parts.push(h1 ? String(h1.textContent || '').slice(0, 60) : '');
      var host = document.querySelector('main,[role=main],#dp,#container') || document.body;
      var money = host ? moneyNodes(host, 3) : [];
      for (var i = 0; i < money.length; i++) parts.push(String(money[i].textContent || '').trim());
    } catch (e) {}
    return parts.join('|');
  }

  function setupChoices() {
    if (!acOn('choices')) return;
    setupNativeChoices();
    setupAriaChoices();
    lastVariantKey = variantKey();
  }

  // ------------------------------------------------- session + engagement
  //
  // GA4's headline number is engagement time, and it is not wall-clock time on
  // the page: a tab left open overnight is not twelve hours of engagement.
  // Only time the page was actually visible counts, which is the same
  // distinction the section dwell clock makes.

  var engagedMs = 0;
  var engagedSince = document.hidden ? 0 : Date.now();

  function engagedTotal() {
    return Math.round(engagedMs + (engagedSince ? Date.now() - engagedSince : 0));
  }

  function onEngagementVisibility() {
    if (document.hidden) {
      if (engagedSince) { engagedMs += Date.now() - engagedSince; engagedSince = 0; }
    } else if (!engagedSince) {
      engagedSince = Date.now();
    }
  }

  function startSession() {
    // isNewSession is set as a side effect of minting the id, and nothing has
    // asked for it yet on this page load. Resolving it here rather than
    // relying on the first track() call is the difference between
    // $session_start firing for every new session and firing only when a
    // $first_visit happens to precede it.
    getSessionId();
    var attr = getAttribution();

    // first_visit before session_start, so the ordering in the table matches
    // the ordering of what happened.
    if (isFirstVisit) {
      track('$first_visit', mergeProps(attr, clientContext()));
    }
    if (isNewSession) {
      track('$session_start', mergeProps(attr, clientContext()));
    }
  }

  var leaveSent = false;
  function sendPageLeave() {
    if (leaveSent) return;
    leaveSent = true;
    onEngagementVisibility();
    track('$page_leave', {
      engaged_ms: engagedTotal(),
      // Wall clock alongside it, because the gap between the two is how much
      // of a "long visit" was actually a tab left open.
      elapsed_ms: Date.now() - pageOpenedAt,
      max_scroll_pct: maxScrollPct,
      path: location.pathname
    });
  }

  var pageOpenedAt = Date.now();
  var maxScrollPct = 0;

  function patchHistory() {
    var lastPath = location.pathname + location.search;
    var lastPathname = location.pathname;
    function onChange() {
      window.setTimeout(function () {
        var now = location.pathname + location.search;
        if (now === lastPath) return;
        lastPath = now;
        // A variant swap rewrites the query string and leaves the path
        // alone -- the same event a full navigation would swallow.
        checkVariantChange(lastPathname);
        var pathChanged = location.pathname !== lastPathname;
        lastPathname = location.pathname;
        if (!pathChanged) return;   // same page, different variant: not a pageview
        flushPartialReads();
        flushMedia();
        onNavigate(false);
      }, 50);
    }
    ['pushState', 'replaceState'].forEach(function (name) {
      var original = history[name];
      if (typeof original !== 'function') return;
      history[name] = function () {
        var result = original.apply(this, arguments);
        onChange();
        return result;
      };
    });
    window.addEventListener('popstate', onChange);
  }

  // ------------------------------------------------------------ coverage

  /**
   * Which rules can actually fire on this page.
   *
   * The whole matching layer is guesswork over prose the AI read, so the
   * useful question during setup is not "did an event fire" but "does this
   * rule resolve to anything at all here". Rules reporting 0 need a
   * data-iq-event annotation or a spec override.
   */
  function coverage() {
    var report = [];
    for (var r = 0; r < CONFIG.rules.length; r++) {
      var rule = CONFIG.rules[r];
      var found = 0;
      var kinds = [];
      for (var t = 0; t < rule.triggers.length; t++) {
        var trigger = rule.triggers[t];
        kinds.push(trigger.type);
        if (trigger.type === 'click') {
          var nodes = toArray(document.querySelectorAll(CLICKABLE));
          if (trigger.selector) {
            try {
              var extra = toArray(document.querySelectorAll(trigger.selector));
              for (var n = 0; n < extra.length; n++) {
                // A <button> matches both CLICKABLE and most trigger
                // selectors; counting it twice inflates the number people
                // use to judge whether a rule is wired up.
                if (nodes.indexOf(extra[n]) === -1) nodes.push(extra[n]);
              }
            } catch (e) {}
          }
          for (var i = 0; i < nodes.length; i++) {
            if (scoreClick(nodes[i], rule, trigger)) found++;
          }
        } else if (trigger.type === 'visible') {
          if (trigger.selector) {
            try { found += document.querySelectorAll(trigger.selector).length; } catch (e) {}
          }
          if (trigger.heading) found += sectionsMatching(trigger.heading).length;
        } else if (trigger.type === 'submit') {
          var forms = toArray(document.querySelectorAll('form'));
          for (var f = 0; f < forms.length; f++) {
            if (trigger.requiresEmail && !hasEmailField(forms[f])) continue;
            if (!trigger.context || bestContained(formContextText(forms[f]), trigger.context)) found++;
            else if (trigger.emailOnlyFallback && isEmailOnlyForm(forms[f])) found++;
          }
        } else if (trigger.type === 'pageview') {
          if (pathMatches(trigger)) found++;
        }
      }
      var annotated = document.querySelectorAll('[data-iq-event="' + rule.key + '"]').length;
      report.push({
        key: rule.key,
        label: rule.label,
        category: rule.category,
        triggers: kinds.join('+'),
        matches: found + annotated,
        annotated: annotated
      });
    }
    return report;
  }

  // ------------------------------------------------------------------ boot

  function boot() {
    for (var i = 0; i < CONFIG.rules.length; i++) ruleByKey[CONFIG.rules[i].key] = CONFIG.rules[i];

    document.addEventListener('click', handleClick, true);
    document.addEventListener('submit', handleSubmit, true);
    window.addEventListener('scroll', onScrollThrottled, { passive: true });

    document.addEventListener('visibilitychange', function () {
      onDwellVisibility();
      onEngagementVisibility();
      if (document.visibilityState === 'hidden') {
        flushPartialReads();
        flushMedia();
        flush(true);
      }
    });
    window.addEventListener('pagehide', function () {
      flushPartialReads();
      flushMedia();
      sendPageLeave();
      flush(true);
    });

    // Which fields people actually engage with, and which they abandon --
    // the part of a form's story that a submit event cannot tell, because a
    // form that is never submitted emits nothing at all today.
    //
    // Names, types and whether anything was typed. Never values: those are
    // the user's, and a length is enough to distinguish touched from filled.
    if (acOn('fields')) {
      var fieldSeen = {};
      document.addEventListener('blur', function (ev) {
        var el = ev.target;
        if (!el || !el.tagName) return;
        var tag = el.tagName.toLowerCase();
        if (tag !== 'input' && tag !== 'select' && tag !== 'textarea') return;
        var type = (el.getAttribute('type') || tag).toLowerCase();
        if (type === 'password' || type === 'hidden') return; // never, not even the length

        var name = el.getAttribute('name') || el.getAttribute('id') || '(unnamed)';
        var key = name + '|' + type;
        if (fieldSeen[key]) return;
        fieldSeen[key] = true;

        var filled = false;
        try { filled = !!(el.value && String(el.value).length); } catch (e) {}
        track('$field', mergeProps(autoProps(el), {
          field_name: String(name).slice(0, 60),
          field_type: type,
          filled: filled,
          form_id: el.form && el.form.getAttribute ? el.form.getAttribute('id') : undefined,
          match: 'autocapture'
        }));
      }, true); // capture: blur does not bubble
    }

    // Rage clicks: repeated clicks on the same spot mean something looked
    // interactive and did nothing. It is the clearest frustration signal a
    // page emits, and no rule would ever be written for it.
    if (acOn('rage')) {
      var rageHits = [];
      document.addEventListener('click', function (ev) {
        var now = Date.now();
        rageHits = rageHits.filter(function (h) { return now - h.t < 900; });
        rageHits.push({ t: now, x: ev.clientX, y: ev.clientY, el: ev.target });
        var near = rageHits.filter(function (h) {
          return Math.abs(h.x - ev.clientX) < 40 && Math.abs(h.y - ev.clientY) < 40;
        });
        if (near.length >= 3 && !rageHits.reported) {
          rageHits.reported = true;
          var el = ev.target;
          if (el && el.nodeType === 3) el = el.parentElement;
          track('$rage_click', mergeProps(autoProps(el), {
            clicks: near.length,
            interactive: isClickable(el) || undefined,
            match: 'autocapture'
          }));
          rageHits = [];
        }
      }, true);
    }

    // What people highlight and copy -- pricing, an email address, a spec
    // number. Page content they chose, not anything they typed.
    if (acOn('selection')) {
      var lastSel = 0;
      document.addEventListener('copy', function () {
        var text = '';
        try { text = String(window.getSelection()); } catch (e) {}
        if (!text || text.length < 3) return;
        if (Date.now() - lastSel < 1000) return;
        lastSel = Date.now();
        var node = null;
        try { node = window.getSelection().anchorNode; } catch (e) {}
        if (node && node.nodeType === 3) node = node.parentElement;
        track('$copy', mergeProps(node ? autoProps(node) : {}, {
          chars: text.length,
          text: text.trim().slice(0, 120),
          match: 'autocapture'
        }));
      }, true);
    }

    setupChoices();
    patchHistory();
    // Before the first page_view, so a session's first row is its start.
    startSession();
    onNavigate(true);

    if (CONFIG.debug) {
      var report = coverage();
      log('rule coverage on ' + location.pathname);
      if (console.table) console.table(report);
      var missing = report.filter(function (row) { return row.matches === 0; });
      if (missing.length && console.warn) {
        console.warn(
          '[galaxy-iq] ' + missing.length + ' rule(s) match nothing on this page: ' +
          missing.map(function (m) { return m.key; }).join(', ') +
          ' -- add data-iq-event="<key>" to the right element, or override the rule in the spec.'
        );
      }
    }
  }

  window.__galaxyIQ = {
    version: CONFIG.version,
    config: CONFIG,
    track: track,
    flush: function () { flush(false); },
    coverage: coverage,
    products: productReport,
    identity: function () { return { visitor_id: visitorId, session_id: getSessionId() }; }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})(typeof window !== 'undefined' ? window : null, typeof document !== 'undefined' ? document : null);
